import { aiContentPages } from './aiContentPages';
const websiteItems = [{ value: 'mainWeb', title: 'Main website' }, { value: 'Aiweb', title: 'AI website' }];
const websiteField = key => ({ type: 'MultiSelectInput', key, col: '6', information: { label: 'Websites', type: 'local', items: websiteItems, showAllInTable: true, isSearchable: true }, showMain: true });
const aiContentImport = {
  importAiContent: { name: 'Import AI website content', function: 'importAiWebsiteContent', icon: '/images/eye.svg' },
  reviveAiData: { name: 'Revive AI data', function: 'reviveAiData', icon: '/images/remove.svg' },
};
const adminSections = {
    main: { key: 'main', name: 'Main Options', },
    website: { key: 'website', name: 'Website Options', },
    extra: { key: 'extra', name: 'Extra Options', },
    admin: { key: 'admin', name: 'Admin Options', },
    // settings: { key: 'settings', name: 'Settings Options', },

}

const adminPages = {


    rental: {
        key: 'rental',
        title: 'Rental Summary',
        description: 'Rentals list',
        fetchUrl: 'getRentals',
        addUrl: 'addRental',
        editUrl: 'addRental',
        removeUrl: 'removeRental',
        // options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'main',
        options: {},
        // sort: { 'cDate': -1 },
        addNew: -1,
        image: '/images/covers/1.jpg',
        extra: { export: { url: 'rentalExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        postBody: { archived: { $ne: true } },
        populate: ["category"],
        indicators: {
            filter: [[{ key: "status" }, '==', '0']],
            color: '#f7f9ff',
            borderColor: '#fff0f0'
        },

        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },
            // PDF: { key: "PDF", label: '{{lang}}Download Insurance PDF', color: '#677dc4', function: "downloadInsurancePDF", permission: 'view' },
            extendTime: { key: "extendTime", label: '{{lang}}Extend Rental Time', color: '#677dc4', function: "extendRentalTime", permission: 'edit' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },


        tabs: [
            { title: 'Reserved', filter: { "status": '0' } },
            { title: 'In Rentals', filter: { "status": '2' } },
        ],




        headers: [
            // { col: '6', key: '_id', type: 'TextInput', operator:'=',information: { label: 'Id', disabled: true, required: true }, showMain: true, inExport: true },

            { col: '6', key: 'rentalId', type: 'TextInput', information: { label: 'Rental Id', disabled: false, required: true }, showMain: true, inExport: true },

            { col: '6', key: 'status', type: 'SelectInput', fullCol: true, information: { label: 'Status', required: false, type: 'local', default: '0', items: [{ title: "Reserved", value: '0' }, { title: "Waiting For Delivery", value: '1' }, { title: 'In rental', value: '2' }, { title: 'Finished', value: '3', color: '#fff', backgroundColor: '#00CD74' }, { title: 'Cancelled By Requester', value: '10' }, { title: 'Cancelled By Ownner', value: '11' }] }, showMain: true, inExport: true },
            { col: '6', key: 'sourceType', type: 'SelectInput', fullCol: true, information: { label: 'Source', required: false, type: 'local', items: [{ title: "Main", value: 'main' }, { title: "Web Store", value: 'webStore' }] }, showMain: true, inExport: true },
            { col: '6', key: 'cDate', type: 'DateInput', information: { label: 'Reservation date', time: true }, showMain: true, hideInList: true },

            { col: '6', key: 'startDate', type: 'DateInput', information: { label: 'Start date', }, showMain: true, inExport: true },
            { col: '6', key: 'endDate', type: 'DateInput', information: { label: 'End Date', }, showMain: true, inExport: true },


            { col: '6', key: 'requester.company', type: 'TextInput', information: { label: 'User' }, showMain: true, settings: { disabled: true }, hideInList: true },
            { col: '6', key: 'equipment.owner.company', type: 'TextInput', information: { label: 'Owner', }, showMain: true, settings: { disabled: true }, hideInList: true },

            // { col: '6', key: 'tempCategory.name', type: 'TextInput', information: { label: 'Category', }, showMain: true, settings: { disabled: true }, hideInList: true },
            // { key: 'category', type: 'MultiLevelInput', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: '{{country}}' } }, settings: { required: true }, showMain: true, fullCol: true, inExport: true },

            // { key: 'category', type: 'MultiLevelInput', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: '{{country}}' } }, settings: { required: false }, showMain: true, hideInList: true, showInfilter: true, fullCol: true, inExport: true },
            {
                key: 'category', type: 'MultiTreeSelectAddListing', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name', image: 'image', parent: 'parent' }, address: 'getCategories', filter: { "sort": { 'priority': -1 }, select: { body: 0 }, filter: { "deactive": { $ne: true }, "$and": [{ '$or': [{ onlyFor: '0' }, { onlyFor: null }] }] } } }, settings: { required: true },
                dependencies: [{
                    refKey: 'country',
                    targetKey: 'category',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: false,
                    changeHeader: { key: 'information.filter.country', value: '@data.country' },
                    //  changeValue: {
                    //         targetKey: "city",
                    //         value: null,
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.country' }, operator: { value: '!=' }, target: { value: null } }
                    //                 }
                    //             },
                    //         },
                    //     }
                }],
                showMain: true, fullCol: true, inExport: true
            },
            // { title: 'Stage',col:'6', key: 'stage', type: 'stage', showMain: true },

            // { col: '6', key: 'equipmentId', type: 'TextInput', information: { label: 'equipmentId' }, showMain: true, },

            { col: '12', key: 'equipment', type: 'SelectInput', information: { label: 'Equipment', type: 'api', fields: { value: '_id', title: 'equipmentId' }, address: 'getEquipments', filter: { country: '{{country}}' }, linkInfo: { ref: "equipments", loader: "isPostingData", } }, showMain: true },
            // { version: null,col:'6', key: 'paymentStatus', type: 'StatusIndicator', thirdCol: true, information: { label: 'Payments', type: 'local', default: '0', relatedKey: 'paymentsList', items: [{ title: "Pending", value: '0', color: '#eee' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }, { title: 'EXPIRED', value: '3', color: '#FF7D9D' }] }, showMain: true },
            // { version: null,col:'6', key: 'transactionStatus', type: 'StatusIndicator', thirdCol: true, information: { label: 'Transactions', type: 'local', default: '0', relatedKey: 'transactionsList', items: [{ title: "Pending", value: '0', color: '#eee' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }] }, showMain: true },
            // { version: null,col:'6', key: 'guaranteeStatus', type: 'StatusIndicator', thirdCol: true, information: { label: 'Refunds', type: 'local', default: '0', relatedKey: 'refundsList', items: [{ title: "Pending", value: '0', color: '#eee' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }] }, showMain: true },

            { version: 1, dontShowHeader: true, col: '4', key: 'paymentStatus', type: 'NewStatusIndicator', thirdCol: true, information: { label: 'Payments', type: 'local', default: '0', relatedKey: 'financial', valueType: "Invoice", items: [{ title: "Pending", value: '0', color: '#fff' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }, { title: 'EXPIRED', value: '3', color: '#FF7D9D' }], inputClass: 'transparent-input' }, showMain: true },
            { version: 1, dontShowHeader: true, col: '4', key: 'transactionStatus', type: 'NewStatusIndicator', thirdCol: true, information: { label: 'Transactions', type: 'local', default: '0', relatedKey: 'financial', valueType: "Order", items: [{ title: "Pending", value: '0', color: '#fff' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }], inputClass: 'transparent-input' }, showMain: true },
            { version: 1, dontShowHeader: true, col: '4', key: 'guaranteeStatus', type: 'NewStatusIndicator', thirdCol: true, information: { label: 'Refunds', type: 'local', default: '0', relatedKey: 'financial', valueType: "Refund", items: [{ title: "Pending", value: '0', color: '#fff' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }], inputClass: 'transparent-input' }, showMain: true },

            { col: '6', key: 'financial', type: 'ProfitCalculator', showMain: true, hideInList: true, information: { label: 'Total Price', showKey: 'Invoice' } },

            // {col:'6', key: 'invoices 1', type: 'ProfitCalculator', showMain: true, hideInList: true, information: { label: 'profit', showKey: 'Profit' } },


            { col: '12', key: 'remark', type: 'TextInput', information: { label: 'Remark' }, showMain: true },

            { col: '6', key: 'requester', type: 'SelectInput', information: { label: "User's Company", type: 'api', fields: { value: '_id', title: 'company', description: 'name' }, address: 'getUsers', filter: { country: '{{country}}' }, linkInfo: { ref: "users", loader: "isPostingData", } }, showMain: false, disabled: true, inExport: true },

            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: false },
            { type: 'SelectInput', col: '6', key: 'city', information: { label: 'City', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: { country: "{{country}}" } }, settings: { required: true }, showMain: false },
            { col: '6', key: 'address', type: 'TextInput', information: { label: 'Delivey Address', }, showMain: false },
            { col: '6', key: 'project', type: 'TextInput', information: { label: 'Project Name', }, showMain: false, },

            { col: '6', key: 'recipient', type: 'TextInput', information: { label: 'Recipient Name', }, showMain: false },
            { col: '6', key: 'recipientPhone', type: 'TextInput', information: { label: 'Recipient Phone', }, showMain: false },

            { col: '6', key: 'preferredTime', type: 'SelectInput', information: { label: 'Preferred Delivery Time', type: 'local', default: '', items: [{ title: "9am - 10am", value: '9am - 10am' }, { title: "10am - 11am", value: '10am - 11am' }, { title: "11am - 12pm", value: '11am - 12pm' }, { title: '12pm - 1pm', value: '12pm - 1pm' }, { title: '12pm - 1pm', value: '12pm - 1pm' }, { title: '1pm - 2pm', value: '1pm - 2pm' }, { title: '2pm - 3pm', value: '2pm - 3pm' }, { title: '3pm - 4pm', value: '3pm - 4pm' }, { title: '4pm - 5pm', value: '4pm - 5pm' }, { title: '5pm - 6pm', value: '5pm - 6pm' }, { title: "9am - 11am", value: '9am - 11am' }, { title: "11am - 1pm", value: '11am - 1pm' }, { title: "1pm - 3pm", value: '1pm - 3pm' }, { title: "3pm - 5pm", value: '3pm - 5pm' }, { title: "5pm - 7pm", value: '5pm - 7pm' }] }, settings: { required: false }, showMain: false },
            { col: '6', key: 'deliveryMode', type: 'SelectInput', information: { disabled: true, label: 'Preferred delivery mode ', type: 'local', default: '', items: [{ title: "delivery", value: '0' }, { title: "self pickup", value: '1' },] }, settings: { required: false }, showMain: false },

            { col: '6', key: "deliveryImage", type: 'FileInput', information: { label: 'Delivery Document', single: true }, showMain: false, fullCol: false },
            { col: '6', key: 'finalImage', type: 'FileInput', information: { label: 'Collection Document', single: true }, showMain: false, fullCol: false },
            { col: '12', key: 'description', type: 'TextAreaInput', information: { label: 'Description', }, showMain: false },

            { col: '6', key: 'amountSnapshot.total', type: 'TextInput', information: { label: 'Total Price', single: true }, showMain: false, hideInList: true, inExport: true },
            { col: '6', key: 'amountSnapshot.discount', type: 'TextInput', information: { label: 'Discount', single: true }, showMain: false, hideInList: true, inExport: true },
            { col: '6', key: 'amountSnapshot.tax', type: 'TextInput', information: { label: 'GST', single: true }, showMain: false, hideInList: true, inExport: true },

            { key: 'owner', type: 'SelectInput', col: '6', information: { label: 'Equipment Owner', type: 'api', fields: { value: '_id', title: 'company', description: 'name' }, address: 'getUsers', filter: { country: "{{country}}", status: 2 } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: false, showInfilter: true, inExport: true },
            { col: '6', key: '_id', type: 'IdInput', information: { label: '_id', disabled: true, required: false }, showMain: false, inExport: true },

        ],




        pages: [{
            key: 'Payments',
            title: 'Payments',
            tabColor: 'rgb(255, 197, 0)',
            headers: [{
                key: 'financial',
                type: 'TableViewerInput',
                showMain: false,
                information: {
                    label: 'List',
                    inputClass: 'transparent-input',
                },
                addNew: -1,
                actions: {
                    edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openRefModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
                    email: { key: "email", label: '{{lang}}Send Email', color: '#677dc4', function: "sendFinancialEmail", permission: 'edit' },

                    // remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
                },
                dataFilter: { key: 'type', operator: '==', value: 'Invoice' },

                headers: [
                    { key: 'id', type: 'TextInput', showMain: true, col: '6', information: { label: 'ID', disabled: false }, fullCol: false },
                    { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'Done', value: '1' }, { title: "Canceled", value: '-1' },] }, settings: { required: true }, showMain: true },
                    { type: 'DateInput', key: 'date', col: '6', information: { label: 'Payment Date', }, showMain: false },
                    { type: 'DateInput', key: 'dueDate', col: '6', information: { label: 'Due Date', }, showMain: true },
                    { type: 'DateInput', key: 'dateFrom', col: '6', information: { label: 'Start Date', }, showMain: true },
                    { type: 'DateInput', key: 'dateTo', col: '6', information: { label: 'End Date', }, showMain: true },
                    { key: 'calc', type: 'Calculator', information: { label: 'Total Price', }, showMain: true },
                ]
            },]
        },
        {
            key: 'Transactions',
            title: 'Transactions',
            tabColor: 'rgb(0, 122, 255)',
            headers: [{
                key: 'financial',
                type: 'TableViewerInput',
                showMain: false,
                addNew: -1,
                information: {
                    label: 'List',
                    inputClass: 'transparent-input',
                },
                actions: {
                    edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openRefModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
                    email: { key: "email", label: '{{lang}}Send Email', color: '#677dc4', function: "sendFinancialEmail", permission: 'edit' },

                    // remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
                },
                dataFilter: { key: 'type', operator: '==', value: 'Order' },


                headers: [
                    { key: 'id', type: 'TextInput', showMain: true, col: '6', information: { label: 'ID', disabled: false }, fullCol: false },
                    { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'Done', value: '1' }, { title: "Canceled", value: '-1' }] }, settings: { required: true }, showMain: true },
                    { type: 'DateInput', key: 'date', col: '6', information: { label: 'Payment Date', }, showMain: false },
                    { type: 'DateInput', key: 'dueDate', col: '6', information: { label: 'Due Date', }, showMain: true },
                    { type: 'DateInput', key: 'dateFrom', col: '6', information: { label: 'Start Date', }, showMain: true },
                    { type: 'DateInput', key: 'dateTo', col: '6', information: { label: 'End Date', }, showMain: true },
                    { key: 'calc', type: 'Calculator', information: { label: 'Total Price', }, showMain: true },
                ]
            },]
        },
        {
            key: 'Refunds',
            title: 'Refunds',
            tabColor: 'rgb(238, 80, 80)',

            headers: [{
                key: 'financial',
                type: 'TableViewerInput',
                showMain: false,
                addNew: -1,
                information: {
                    label: 'List',
                    inputClass: 'transparent-input',
                },
                dataFilter: { key: 'type', operator: '==', value: 'Refund' },
                actions: {
                    edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openRefModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
                    email: { key: "email", label: '{{lang}}Send Email', color: '#677dc4', function: "sendFinancialEmail", permission: 'edit' },

                    // remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
                },

                headers: [
                    { key: 'id', type: 'TextInput', showMain: true, col: '6', information: { label: 'ID', disabled: false }, fullCol: false },
                    { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'Done', value: '1' }, { title: "Canceled", value: '-1' }] }, settings: { required: true }, showMain: true },
                    { type: 'DateInput', key: 'date', col: '6', information: { label: 'Payment Date', }, showMain: false },
                    { type: 'DateInput', key: 'dueDate', col: '6', information: { label: 'Due Date', }, showMain: true },
                    { type: 'DateInput', key: 'dateFrom', col: '6', information: { label: 'Start Date', }, showMain: true },
                    { type: 'DateInput', key: 'dateTo', col: '6', information: { label: 'End Date', }, showMain: true },
                    { key: 'calc', type: 'Calculator', information: { label: 'Total Price', }, showMain: true },
                ]
            },]
        }
        ],

    },




    invoices: {
        key: 'invoices',
        title: 'Financial Summary',
        description: 'Financial List',
        fetchUrl: 'getFinancials',
        addUrl: 'addFinancial',
        editUrl: 'addFinancial',
        removeUrl: 'removeFinancial',
        fetchOne: 'getOneFinancial',
        pageType: 'form',
        page: 'invoices',
        parent: 'main',
        extra: { export: { url: 'financialExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        populate: ["category"],

        // sort: { 'uDate': -1 },
        image: '/images/covers/7.jpg',

        tabs: [
            { title: 'Invoices', filter: { "type": 'Invoice' } },
            { title: 'Purchase Orders', filter: { "type": 'Order' } },
            { title: 'Refund Notices', filter: { "type": 'Refund' } },
        ],

        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },
            PDF: { key: "PDF", label: '{{lang}}Download PDF', color: '#677dc4', function: "downloadFinancialPDF", permission: 'view' },
            PDFInvoice: { key: "PDF", label: '{{lang}}Original PDF', color: '#677dc4', function: "downloadOriginalFinancialPDF", permission: 'view' },
            PDFInsurance: { key: "PDF", label: '{{lang}}Download Insurance PDF', color: '#677dc4', function: "GetInsurancePdf", permission: 'view' },

            email: { key: "email", label: '{{lang}}Send Email', color: '#677dc4', function: "sendFinancialEmail", permission: 'edit' },
            lateEmail1: { key: "email", label: '{{lang}}Send Payment Reminder', unSelectableLable: '{{lang}}Already Sent', condition: 'sentDateRemindercc', conditionKey: 'type', condition2: 'Invoice', color: '#677dc4', function: "SendEmailLate1", permission: 'view' },
            lateEmail2: { key: "email", label: '{{lang}}Send Late Email 1st', unSelectableLable: '{{lang}}Already Sent', condition: 'sentDateLate1', conditionKey: 'type', condition2: 'Invoice', color: '#677dc4', function: "SendEmailLate2", permission: 'view' },
            lateEmail3: { key: "email", label: '{{lang}}Send Late Email 2nd', unSelectableLable: '{{lang}}Already Sent', condition: 'sentDateLate2', conditionKey: 'type', condition2: 'Invoice', color: '#677dc4', function: "SendEmailLate3", permission: 'view' },
            lateEmail4: { key: "email", label: '{{lang}}Send Late Email 3rd', unSelectableLable: '{{lang}}Already Sent', condition: 'sentDateLate3', conditionKey: 'type', condition2: 'Invoice', color: '#677dc4', function: "SendEmailLate4", permission: 'view' },
            lateEmail5: { key: "email", label: '{{lang}}Send Late Email 4th', unSelectableLable: '{{lang}}Already Sent', condition: 'sentDateLate4', conditionKey: 'type', condition2: 'Invoice', color: '#677dc4', function: "SendEmailLate5", permission: 'view' },

            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },



        headers: [

            { key: 'id', type: 'TextInput', col: '6', information: { label: 'Document No.', disabled: false }, showMain: true, inExport: true },

            { key: 'rentalId', type: 'TextInput', col: '6', information: { label: 'Rental Id', }, showMain: true, inExport: true },
            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Creation Date', disabled: false }, showMain: true, inExport: true },

            { key: 'type', type: 'SelectInput', col: '6', information: { label: 'Document Type', type: 'local', items: [{ title: "Invoice", value: 'Invoice', color: '#000', backgroundColor: 'rgb(255, 197, 0)' }, { title: 'Order', value: 'Order', color: '#fff', backgroundColor: '#007aff' }, { title: 'Refund', value: 'Refund', color: '#fff', backgroundColor: '#ee5050' }], required: true }, showMain: true, inExport: true },
            { key: 'user', type: 'SelectInput', col: '6', information: { label: "User's Companey", type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: { country: "{{country}}" }, linkInfo: { ref: "users", loader: "isPostingData", } }, showMain: true, showInfilter: true, inExport: true },
            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {}, required: true }, required: true, showMain: false },

            // { key: 'creator.company', type: 'TextInput', col: '6', information: { label: 'Company', }, showMain: true, hideInList: true },
            { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Payment Status', type: 'local', items: [{ title: "pending", value: '0' }, { title: 'done', value: '1', color: '#fff', backgroundColor: '#00CD74' }, { title: 'canceled', value: '-1' }], required: true }, showMain: true, inExport: true },
            { key: 'emailStatus', type: 'SelectInput', col: '6', information: { label: 'Email Status', type: 'local', items: [{ title: "pending", value: '0' }, { title: 'Sent', value: '1' }] }, showMain: false, settings: { disabled: true } },

            { key: 'description', col: '6', information: { label: 'Description', }, type: 'text', showMain: false, },

            { key: 'dueDate', type: 'DateInput', col: '6', information: { label: 'Payment Due Date', }, showMain: true, inExport: true },
            { key: 'date', type: 'DateInput', col: '6', information: { label: 'Payment Date', }, showMain: false, },
            { key: 'sentDate', type: 'DateInput', col: '6', information: { label: 'Email Sent Date', }, showMain: false, },


            { key: 'dateFrom', type: 'DateInput', col: '6', information: { label: 'Rental Start Date', }, showMain: false, inExport: true },
            { key: 'dateTo', type: 'DateInput', col: '6', information: { label: 'Rental End Date', }, showMain: false, inExport: true },

            { key: 'DontSendInsurance', type: 'SwitchInput', col: '6', information: { label: "Don't Send Insurance Cover Note", }, showMain: false },
            { key: 'calc', type: 'Calculator', col: '12', information: { label: 'Calculator', }, showMain: true, fullCol: true },


            { key: 'rental', type: 'TextInput', col: '6', information: { label: 'Rental', }, showMain: false, hideInList: true },
            { key: 'equipment', type: 'SelectInput', col: '6', information: { label: 'Equipment', type: 'api', fields: { value: '_id', title: 'equipmentId' }, address: 'getEquipments', filter: {} }, settings: { required: true, url: 'getOneEquipment', showInfo: true, disabled: true }, hideInList: true, showMain: false },

            // { key: 'requester', type: 'SelectInput', col: '6', information: { label: 'Requester Company', type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: {} }, showMain: false, disabled: true, inExport: true },
            // { key: 'owner', type: 'SelectInput', col: '6', information: { label: 'Equipment Owner', type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: {} }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: false, hideInList: true, inExport: true },
            { key: 'category', type: 'MultiSelectInput', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: '{{country}}' } }, settings: { required: false }, showMain: true, hideInList: true, fullCol: true, showInfilter: true, inExport: true },



            {
                title: 'List',
                key: 'list',
                type: 'TableViewerInput',
                showMain: false,
                information: {
                    label: 'List',
                    inputClass: 'transparent-input',
                    inExport: true
                },
                actions: {
                    // add: { key: "add", label: "{{lang}}add", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", loader: "isPostingData" },
                    edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", loader: "isPostingData", permission: 'view' },
                    remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal", permission: 'delete' },
                },

                headers: [

                    { key: 'title', type: 'TextInput', showMain: true, col: '6', information: { label: 'Title', disabled: false }, fullCol: false },
                    { key: 'amount', type: 'PriceInput', col: '6', information: { label: 'Amount', negativeAllowed: true }, showMain: true, fullCol: false },
                    { key: 'tax', type: 'SwitchInput', col: '6', information: { label: 'Is Tax', }, showMain: false, },
                    { key: 'discount', type: 'SwitchInput', col: '6', information: { label: 'Is Discount', }, showMain: false, },
                    { key: 'taxFree', type: 'SwitchInput', col: '6', information: { label: 'Tax Free', }, showMain: false, },
                    { key: 'discountFree', type: 'SwitchInput', col: '6', information: { label: 'Discount Free', }, showMain: false, },
                    { key: 'description', type: 'TextAreaInput', col: '12', information: { label: 'Description', }, showMain: false, fullCol: true },

                    // { key: 'id', type: 'TextInput', showMain: true, information: { label: 'ID', disabled: false }, fullCol: false },
                    // { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'Done', value: '1' }] }, settings: { required: true }, showMain: true },
                    // { type: 'DateInput', key: 'date', information: { label: 'Payment Date', }, showMain: false },
                    // { type: 'DateInput', key: 'dueDate', information: { label: 'Due Date', }, showMain: true },
                    // { type: 'DateInput', key: 'dateFrom', information: { label: 'Start Date', }, showMain: true },
                    // { type: 'DateInput', key: 'dateTo', information: { label: 'End Date', }, showMain: true },
                    // { key: 'calc', type: 'calculator', information: { label: 'Total Price', }, showMain: true },


                    // { title: 'Edit', type: 'button', function: 'edit', options: { color: "#78b2d0" }, showMain: true },
                    // { title: 'Remove', type: 'button', function: 'remove', options: { color: "#dd8aa4" }, showMain: true }
                ]
            },


            { col: '6', key: 'amountSnapshot.ptotal', type: 'TextInput', information: { label: 'Total Price', single: true }, showMain: false, hideInList: true, inExport: true },
            { col: '6', key: 'amountSnapshot.discount', type: 'TextInput', information: { label: 'Discount', single: true }, showMain: false, hideInList: true, inExport: true },
            { col: '6', key: 'amountSnapshot.tax', type: 'TextInput', information: { label: 'GST', single: true }, showMain: false, hideInList: true, inExport: true },
            { key: 'sentDateReminder', type: 'DateInput', col: '6', information: { label: 'Reminder Email Sent Date', }, showMain: false, },
            { key: 'sentDateLate1', type: 'DateInput', col: '6', information: { label: '1st Late Email Sent Date', }, showMain: false, },
            { key: 'sentDateLate2', type: 'DateInput', col: '6', information: { label: '2nd Late Email Sent Date', }, showMain: false, },
            { key: 'sentDateLate3', type: 'DateInput', col: '6', information: { label: '3rd Late Email Sent Date', }, showMain: false, },
            { key: 'sentDateLate4', type: 'DateInput', col: '6', information: { label: '4th Late Email Sent Date', }, showMain: false, },

        ]
    },




    wiki: {
        key: 'wiki',
        page: 'wiki',
        title: 'Equipment Wiki',
        description: 'wikis List',
        fetchUrl: 'getWikis',
        addUrl: 'addWiki',
        editUrl: 'addWiki',
        removeUrl: 'removeWiki',
        pageType: 'form',
        parent: 'main',
        populate: ["category", "brand"],
        // options: { noAddNew: true },
        // addNew: -1,
        extra: { export: { url: 'wikiExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

        tabs: [
            { title: 'Not approved', filter: { "approved": false } },
        ],


        image: '/images/covers/2.jpg',
        headers: [

            { key: 'model', type: 'TextInput', col: '6', information: { label: 'Model', }, showMain: true, inExport: true },
            { key: 'slug', type: 'TextInput', col: '6', information: { label: 'Slug', }, showMain: true, inExport: true },
            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Creation Date', disabled: true }, showMain: true, inExport: true },

            // { key: 'category', type: 'MultiLevelInput', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name' }, address: 'categoriesGetAllForWiki', filter: {} }, settings: { required: true }, showMain: true, inExport: true, fullCol: true },
            {
                key: 'category', type: 'MultiTreeSelectAddListing', col: '6', information: {
                    label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name', image: 'image', parent: 'parent' }, address: 'getCategories', filter: {
                        "sort": { 'priority': -1 }, select: { body: 0 }, filter: {
                            "deactive": { $ne: true }
                            // , "$and": [{ '$or': [{ onlyFor: '0' }, { onlyFor: null }]}]
                        }
                    }
                }, settings: { required: true },
                // dependencies: [{
                //     refKey: 'country',
                //     targetKey: 'category',
                //     conditions: {
                //         root: {
                //             id: 'root',
                //             action: 'or',
                //             conditions: {
                //                 1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                //             }
                //         }
                //     },
                //     show: false,
                //     init: false,
                //     changeHeader: { key: 'information.filter.country', value: '@data.country' },
                //     //  changeValue: {
                //     //         targetKey: "city",
                //     //         value: null,
                //     //         conditions: {
                //     //             root: {
                //     //                 id: 'root',
                //     //                 action: 'and',
                //     //                 conditions: {
                //     //                     1: { id: 1, source: { value: '@data.country' }, operator: { value: '!=' }, target: { value: null } }
                //     //                 }
                //     //             },
                //     //         },
                //     //     }
                // }],
                showMain: true, fullCol: true, inExport: true
            },
            { key: 'brand', type: 'SelectInput', col: '6', information: { label: 'Brand', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getBrands', filter: {} }, inExport: true, showMain: true },

            { key: 'image', type: 'ImageInput', information: { label: 'Image', single: false, cropper: true, }, showMain: true, fullCol: true },

            { key: 'catalogue', type: 'FileInput', col: '12', information: { label: 'Catalogue', single: false }, fullCol: true, settings: { required: true }, showMain: true },

            // {
            //     type: 'AttributesLoader',
            //     key: 'attributes',
            //     ref: 'category',
            //     information: { label: 'Attributes', inputClass: 'transparent-input', refKey: 'categories', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getAttributes', filter: {} },
            //     showMain: false,
            //     fullCol: true,
            //     col: '12',
            //     dependencies: [{
            //         refKey: 'category',
            //         targetKey: 'attributes',
            //         conditions: {
            //             root: {
            //                 id: 'root',
            //                 action: 'and',
            //                 conditions: {
            //                     1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: "1" } }
            //                 }
            //             },
            //         },
            //         show: true,
            //         init: true,


            //     }],

            // },
            {
                type: 'AttributesLoader',
                key: 'attributes',
                ref: 'category',
                information: { label: 'Attributes', inputClass: 'transparent-input', refKey: 'categories', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getAttributes', filter: { country: '{{country}}' } },
                showMain: false,
                fullCol: true,
                // dependencies: [{ type: 'filter', dontRefresh: true, action: 'enable', field: 'category', param: 'categories' }],
                col: '12',
                dependencies: [{
                    refKey: 'category',
                    targetKey: 'attributes',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: "1" } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                    // changeValue: {
                    //     targetKey: "latitude",
                    //     value: null,
                    //     conditions: {
                    //         root: {
                    //             id: 'root',
                    //             action: 'and',
                    //             conditions: {
                    //                 1: { id: 1, source: { value: '@data.settings.haslLocation' }, operator: { value: '==' }, target: { value: false } }
                    //             }
                    //         },
                    //     },
                    // }
                    changeHeader: { key: 'information.refValue', value: '@data.category', },

                }],

            },


            { key: 'approved', type: 'SwitchInput', col: '6', information: { label: 'Approved', default: true, required: false }, showMain: true, inExport: true },

        ]
    },



    // ticketing: {
    //     key: 'ticketing',
    //     title: 'Ticketing',
    //     description: 'Ticketing list',
    //     fetchUrl: 'getTickets',
    //     addUrl: 'postTicket',
    //     removeUrl: 'removeTicket',
    //     fetchOneUrl: 'getOneTicket',
    //     addOneUrl: 'postTicketReply',

    //     pageType: 'list',
    //     parent: 'website',

    //     options: {},
    //     sort: { 'values.priority': -1 },
    //     image: '/images/back1.jpg',
    //     headers: [
    //         // { key: 'user', type: 'AdvancedSelectInput', col: "6", information: { label: '{{lang}}User', address: 'getUsers', filter: {}, fields: { title: 'phone', description: "fullname", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },

    //         // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true } },
    //         // { key: 'id', type: 'TextInput', information: { label: '{{lang}}Id', placeholder: '{{lang}}Id', required: false } },

    //         { key: 'body', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
    //         { key: 'title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
    //         // { key: 'values.parent', type: 'TextInput', information: { label: '{{lang}}parent', placeholder: '{{lang}}parent', required: false } },
    //         // { type: 'SelectInput', key: 'values.parent', col: '12', information: { label: '{{lang}}parent', address: 'getContents', filter: { page: 'DocumentsCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: false },
    //         // { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: false } },

    //         { type: 'SelectInput', key: 'status', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: '{{lang}}Pending' }, { value: '2', title: '{{lang}}Waiting for answer' }, { value: '3', title: '{{lang}}Answered' }, { value: '-1', title: '{{lang}}Closed' }], isSearchable: true, placeholder: '{{lang}}Status', required: true }, showMain: true },

    //     ]
    // },



    equipments: {
        key: 'equipments',
        title: 'Equipment Listing Summary',
        description: 'Equipments List',
        fetchUrl: 'getEquipments',
        fetchOne: 'getOneEquipment',
        addUrl: 'addEquipment',
        convertUrl: 'addSellFromRental',
        editUrl: 'addEquipment',
        removeUrl: 'removeEquipment',
        pageType: 'form',
        parent: 'main',
        populate: ["category", 'brand', 'country', 'owner'],
        // importAPI: ["category", 'brand','owner','country','city'],
        // importAPIName: [{ key: 'category', title: "name", schema: 'categories', isTree: true, treeKey: 'parent' }, { key: 'brand', title: "name", schema: 'brands' }, { key: 'owner', title: "company", schema: 'users' }, { key: 'country', title: "name", schema: 'countries' }, { key: 'city', title: "name", schema: 'places', isArray: true }],
        importAPIName: [{ key: 'category', title: "name", value: '_id', schema: 'categories', isTree: true, treeKey: 'parent' }, { key: 'model', helpingKey: 'category', title: "model", secondtTitle: 'slug', value: 'model', schema: 'wikis', secondKey: 'catalogue', secondValue: 'catalogue', thirdKey: 'attributes', thirdValue: 'attributes' }, { key: 'brand', title: "name", value: '_id', schema: 'brands', canImport: true }, { key: 'owner', title: "userId", value: '_id', schema: 'users' }, { key: 'city', title: "name", value: '_id', schema: 'places', isArray: true }, { key: 'address', parentKey: 'mainAddress', isAddress: true, secondKey: 'location', thirdKey: 'postalCode', includeCity: true }, { key: 'country', title: "name", value: '_id', schema: 'countries' }, { key: 'equipmentId', app: 'equipments', isAutoGen: true, hasCountry: true }, { key: 'daily', parentKey: 'price' }, { key: 'weekly', parentKey: 'price' }, { key: 'monthly', parentKey: 'price' }, { key: 'sixMonths', parentKey: 'price' }, { key: 'oneYear', parentKey: 'price' }, { key: 'twoYears', parentKey: 'price' }, { key: 'delivery', parentKey: 'price' }],
        options: { noAddNew: true },

        addNew: -1,
        extra: { export: { url: 'equipmentExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' }, import: { schema: 'equipments', name: 'import', function: 'openImport', icon: '/images/eye.svg' } },

        tabs: [
            { title: 'Pending', filter: { "active": '0' } },
            {
                title: 'Need Review', filter: {
                    $and: [
                        { 'importError': { $ne: null } },
                        { 'importError': { $ne: '' } }
                    ]
                }
            },
        ],

        page: 'equipments',

        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },

            convertToSell: { key: "convert", label: '{{lang}}Convert To Sell', unSelectableLable: '{{lang}}Already A Sell', condition: 'sellEq', color: '#677dc4', function: "openConvertionModal", permission: 'create' },


            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },



        image: '/images/covers/2.jpg',
        convertHeaders: [




            { key: 'price', type: 'PriceInput', col: '6', information: { label: 'Price', }, showMain: true, inExport: true },
            { type: 'SelectInput', key: 'currency', col: '6', information: { label: 'Currency', type: 'api', fields: { value: '_id', title: 'currency' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: false, inExport: true },

            { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' },] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'condition', type: 'SelectInput', col: '6', information: { label: 'Condition', type: 'local', default: '0', items: [{ title: 'New', value: "new" }, { title: 'Used', value: "used" }, { title: 'Scrap', value: "scrap" }] }, settings: { required: true }, showMain: true, inExport: true },



            { key: 'workingHour', type: 'NumberInput', col: '6', information: { label: 'working hour', }, showMain: false, fullCol: true, inExport: true },



            { key: 'deliveryWeekly', type: 'SelectInput', information: { label: 'Deliver Lead Time', type: 'local', items: [{ title: 'Ready For Deliver', value: "readyfordeliver" }, { title: '1 Week', value: "1 Week" }, { title: '2 Week', value: "twoWeek" }, { title: '3 Week', value: "threeWeek" }, { title: '4 Week', value: "fourWeek" }, { title: '2 Months', value: "twoMonths" }, { title: '3 Months', value: "threeMonths" }], placeholder: 'Deliver Lead Time', required: false } },






            { key: 'defects', type: 'TextAreaInput', col: '12', information: { label: 'Defects Declaration', }, showMain: false, inExport: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: 'Description', }, showMain: false, inExport: true },
            { key: 'active', type: 'SelectInput', col: '6', information: { label: 'Active', placeholder: 'Select ...', type: 'local', default: '0', items: [{ title: "Not Active", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' }, { title: "Blocked By Admin", value: '-2' },] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'sellFeatured', type: 'SwitchInput', col: '6', information: { label: 'Featured', required: false }, showMain: false },
            { key: 'sellRecommended', type: 'SwitchInput', col: '6', information: { label: 'Recommended', required: false }, showMain: false },


        ],
        headers: [

            { key: 'equipmentId', type: 'TextInput', information: { label: 'Equipment Id', disabled: true }, showMain: true, settings: { disabled: true }, fullCol: true, inExport: true, disabled: true },
            { key: 'image', type: 'ImageInput', information: { label: 'Marketplace Image', single: false, cropper: true, ratio: '1:1' }, showMain: true, fullCol: true },
            { key: 'webstoreImage', type: 'ImageInput', information: { label: 'Webstore Image', single: false, cropper: true, ratio: '1:1' }, showMain: false, fullCol: true },

            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Creation Date', disabled: true }, showMain: true, inExport: true },

            // { key: 'tempAddress', type: 'TextInput', col: '6', information: { label: 'In Rental Status', }, showMain: true, settings: { disabled: true }, fullCol: true, inExport: true },
            // { key: 'reservations.[0].rental.status', type: 'TextInput', col: '6', information: { label: 'In Rental Status', }, showMain: true, settings: { disabled: true }, fullCol: true, inExport: true },
            { col: '6', key: 'reservations.[length-1].rental.status', type: 'SelectInput', fullCol: true, information: { label: 'In Rental Status', required: false, type: 'local', items: [{ title: "Reserved", value: '0' }, { title: "Waiting For Delivery", value: '1' }, { title: 'In rental', value: '2' }, { title: 'Finished', value: '3', color: '#fff', backgroundColor: '#00CD74' }, { title: 'Cancelled By Requester', value: '10' }, { title: 'Cancelled By Ownner', value: '11' }] }, showMain: true, inExport: true },

            // { key: 'owner.company', type: 'TextInput', col: '6', information: { label: 'Company', }, showMain: true, settings: { disabled: true }, fullCol: true, hideInList: true, inExport: true },

            { key: 'owner', type: 'SelectInput', col: '6', information: { isSearchable: true, limit: 20, label: 'Owner', type: 'api', fields: { value: '_id', description: "email", title: 'company' }, address: 'getUsers', filter: { country: "{{country}}", status: 2 }, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: true, inExport: true },
            {
                key: 'category', type: 'MultiTreeSelectAddListing', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name', image: 'image', parent: 'parent' }, address: 'getCategories', filter: { "sort": { 'priority': -1 }, select: { body: 0 }, filter: { "deactive": { $ne: true }, "$and": [{ '$or': [{ onlyFor: '0' }, { onlyFor: null }] }] } } }, settings: { required: true },
                dependencies: [{
                    refKey: 'country',
                    targetKey: 'category',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: true,
                    changeHeader: { key: 'information.filter.country', value: '@data.country' },
                    //  changeValue: {
                    //         targetKey: "city",
                    //         value: null,
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.country' }, operator: { value: '!=' }, target: { value: null } }
                    //                 }
                    //             },
                    //         },
                    //     }
                }],
                showMain: true, fullCol: true, inExport: true
            },
            { key: 'brand', type: 'SelectInput', col: '6', information: { label: 'Brand', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getBrands', filter: {} }, showMain: true, inExport: true },
            { key: 'model', type: 'TextInput', col: '6', information: { label: 'Model', }, showMain: true, inExport: true },
            { key: 'serialNumber', type: 'TextInput', col: '6', information: { label: 'Serial Number', }, showMain: true, inExport: true },

            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true, inExport: true },
            {
                type: 'SelectInput', key: 'mainAddress.city', information: { label: 'City', placeholder: 'City ...', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: {}, required: false },
                dependencies: [{
                    refKey: 'country',
                    targetKey: 'mainAddress.city',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: false,
                    changeHeader: { key: 'information.filter.country', value: '@data.country' },
                    //  changeValue: {
                    //         targetKey: "city",
                    //         value: null,
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.country' }, operator: { value: '!=' }, target: { value: null } }
                    //                 }
                    //             },
                    //         },
                    //     }
                }],
                showMain: true
            },
            {
                key: 'city', type: 'MultiSelectInput', col: '6', information: { label: 'Available Locations', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: {} }, settings: { required: true },
                dependencies: [{
                    refKey: 'country',
                    targetKey: 'city',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: false,
                    changeHeader: { key: 'information.filter.country', value: '@data.country' },
                }],
                showMain: false, fullCol: true
            },

            // { key: 'category', type: 'MultiLevelInput', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: null, reference: 'parent', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: '{{country}}' },'$or': [{ onlyFor: '0' }, { onlyFor: null }] }, settings: { required: true }, showMain: true, fullCol: true, inExport: true },


            // { key: 'year', type: 'NumberInput', col: '6', information: { label: 'Year of manufacturing', }, showMain: false, fullCol: true, inExport: true },
            { type: 'CalendarRental', col: '6', key: 'year', information: { extraOption: 'Brand New', label: 'Manufacture Year', placeholder: 'Input Year', required: true }, showMain: false },

            { key: 'shortTermSupport', type: 'SwitchInput', col: '6', information: { label: 'Short Term Support', required: false }, showMain: false },
            { key: 'price.daily', type: 'PriceInput', col: '6', information: { label: 'Daily Price', }, showMain: true, inExport: true },
            { key: 'price.weekly', type: 'PriceInput', col: '6', information: { label: 'Weekly Price', }, showMain: true, inExport: true },
            { key: 'price.monthly', type: 'PriceInput', col: '6', information: { label: 'Monthly Price', }, showMain: true, inExport: true },
            { key: 'longTermSupport', type: 'SwitchInput', col: '6', information: { label: 'Long Term Support', required: false }, showMain: false },
            { key: 'price.sixMonths', type: 'PriceInput', col: '6', information: { label: '6 Months Price', }, showMain: false, fullCol: true, inExport: true },
            { key: 'price.oneYear', type: 'PriceInput', col: '6', information: { label: '1 Year Price', }, showMain: false, fullCol: true, inExport: true },
            { key: 'price.twoYears', type: 'PriceInput', col: '6', information: { label: '2 Years Price', }, showMain: false, fullCol: true, inExport: true },
            { key: 'price.delivery', type: 'PriceInput', col: '6', information: { label: 'Delivery Price', }, showMain: true, inExport: true },

            { key: 'onlySelfPickup', type: 'SwitchInput', col: '6', information: { label: 'Only Self Pickup', required: false }, showMain: false },


            { type: 'TextInput', key: 'mainAddress.address', information: { label: 'Address', placeholder: 'Full Address', required: false }, showMain: false },
            { type: 'TextInput', key: 'mainAddress.postalCode', col: '6', information: { label: 'zip code', placeholder: 'zip code / postal code', required: false }, showMain: false },
            // { type: 'TextInput', key: 'mainAddress.project', col: '6', information: { label: 'Project Name', placeholder: 'Project Name', required: true }, showMain: true },

            { type: 'MapInput', key: 'mainAddress.location', col: '12', information: { label: 'location', placeholder: 'Project Name', required: false, country: '{{country}}', mainAddress: true }, showMain: false },

            // { type: 'SelectInput', key: 'city', information: { label: 'City', placeholder: 'City ...', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: { country: "{{country}}" }, sort: { 'values.priority': 1 }, required: true }, showMain: false },
            // // { type: 'TreePlainSelect', key: 'city', information: { label: 'City', placeholder: 'City ...', type: 'api', fields: { value: '_id', title: 'name', parent: 'parent' }, address: 'getPlaces', filter: { country: this.props.user?.info?.country?.slug }, sort: { 'name': 1 }, required: true }, showMain: false },
            // { type: 'TextInput', key: 'address', information: { label: 'Address', placeholder: 'Full Address', required: true }, showMain: true },
            // { type: 'TextInput', key: 'postalCode', col: '6', information: { label: 'zip code', placeholder: 'zip code / postal code', required: true }, showMain: true },
            // // { type: 'TextInput', key: 'project', col: '6', information: { label: 'Project Name', placeholder: 'Project Name', required: true }, showMain: true },
            // { type: 'MapInput', key: 'location', col: '12', information: { label: 'location', placeholder: 'Project Name', required: true, country: '{{country}}' }, showMain: true },


            { key: 'catalogue', type: 'FileInput', col: '12', information: { label: 'Catalogue', single: false }, showMain: false, fullCol: true, settings: { required: true }, },

            { key: 'title', type: 'TextInput', col: '12', information: { label: 'Title', }, showMain: true, settings: { disabled: true }, fullCol: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: 'Description', }, settings: { disabled: true }, fullCol: true, showMain: false },


            ///// dependencies
            {
                type: 'AttributesLoader',
                key: 'attributes',
                ref: 'category',
                information: { label: 'Attributes', inputClass: 'transparent-input', refKey: 'categories', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getAttributes', filter: { country: '{{country}}' } },
                showMain: false,
                fullCol: true,
                // dependencies: [{ type: 'filter', dontRefresh: true, action: 'enable', field: 'category', param: 'categories' }],
                col: '12',
                dependencies: [{
                    refKey: 'category',
                    targetKey: 'attributes',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: "1" } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                    // changeValue: {
                    //     targetKey: "latitude",
                    //     value: null,
                    //     conditions: {
                    //         root: {
                    //             id: 'root',
                    //             action: 'and',
                    //             conditions: {
                    //                 1: { id: 1, source: { value: '@data.settings.haslLocation' }, operator: { value: '==' }, target: { value: false } }
                    //             }
                    //         },
                    //     },
                    // }
                    changeHeader: { key: 'information.refValue', value: '@data.category', },

                }],

            },



            { key: 'wiki', type: 'SelectInput', col: '6', information: { label: 'Wiki', type: 'api', fields: { value: 'slug', title: 'model' }, address: 'getWikis', filter: { sort: { 'model': 1 }, limit: 10000 } }, showMain: false },

            { key: 'active', type: 'SelectInput', col: '6', information: { label: 'Active', placeholder: 'Select ...', type: 'local', items: [{ title: "Not Active", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' }, { title: "Blocked By Admin", value: '-2' },] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'activeOnlyFor', type: 'SelectInput', col: '6', information: { label: 'Active Only For', placeholder: 'Select ...', type: 'local', items: [{ title: "Main Website", value: 'Main' }, { title: 'Web Store', value: 'Store' }, { title: "Main Website & Web Store", value: 'Main&Store' }] }, showMain: true, inExport: true },

            //// Invert
            { key: 'unavailable', type: 'SwitchInput', col: '6', information: { label: 'Available', invert: true, required: false }, showMain: true, inExport: true },
            { key: 'featured', type: 'SwitchInput', col: '6', information: { label: 'Featured', required: false }, showMain: false },
            { key: 'recommended', type: 'SwitchInput', col: '6', information: { label: 'Recommended', required: false }, showMain: false },

            { key: 'sold', type: 'SwitchInput', col: '6', information: { label: 'Sold', }, showMain: false, },

            { key: 'note', type: 'TextAreaInput', col: '6', information: { label: 'Note', }, showMain: false, },
            { type: 'DateInput', key: 'certExpDate', col: '6', information: { label: 'CERT Expire Date', }, showMain: false, },
            { col: '6', key: 'certFile', type: 'FileInput', information: { label: 'LE CERT File', single: true }, showMain: false, fullCol: false },
            { type: 'TextAreaInput', key: 'importError', information: { label: 'Need Review', }, showMain: false, fullCol: true },
            { type: 'TextAreaInput', key: 'remark', information: { label: 'Admin Remark', }, showMain: true, fullCol: true },
            // { key: 'webstoreImage', type: 'ImageInput', information: { label: 'Image', single: false, cropper: true, ratio: '1:1' }, showMain: false, fullCol: true },

        ]
    },





    categories: {
        key: 'categories',
        title: 'Equipment Category',
        description: 'Categories List',
        fetchUrl: 'getCategories',
        addUrl: 'addCategory',
        editUrl: 'addCategory',
        removeUrl: 'removeCategory',
        pageType: 'form',
        page: 'categories',
        parent: 'main',
        image: '/images/covers/4.jpg',
        hasTranslation: true,
        extra: { export: { url: 'categoryExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' }, import: { schema: 'categories', name: 'import', function: 'openImport', icon: '/images/eye.svg' } },
        // extra: { export: { url: 'categoryExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        postBody: { country: '*' },
        populate: ["parent"],
        // importAPI: ["parent"],
        importAPIName: [{ key: 'parent', title: "name", schema: 'categories' }],

        headers: [
            { type: 'TextInput', key: 'name', col: '6', information: { label: 'Name', }, showMain: true, inExport: true, hasTranslation: true },
            // { type: 'TextInput', key: '_id', col: '6', information: { label: '_id', }, showMain: true, inExport: true, hasTranslation: true },
            { type: 'TextInput', key: 'slug', col: '6', information: { label: 'Slug', }, showMain: true, inExport: true },
            { key: 'image', type: 'ImageInput', col: '12', information: { label: 'Image', single: true, cropper: false }, showMain: true, fullCol: true },
            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Creation Date', disabled: true }, showMain: true, inExport: true },

            { type: 'NumberInput', key: 'priority', col: '6', information: { label: 'Priority', }, showMain: false },

            { type: 'NumberInput', key: 'discount', col: '6', information: { label: 'discount', }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'deposit', col: '6', information: { label: 'deposit', }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'surcharge', col: '6', information: { label: 'surcharge', }, showMain: true, inExport: true },
            {
                type: 'SubformInput',
                key: 'countryDiscount',
                col: '12',
                information: {
                    label: 'countries discount and deposit',
                    headers: [
                        { type: 'SelectInput', key: 'country', col: '4', information: { label: '{{lang}}country', placeholder: '{{lang}}country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, showMain: true, fullCol: true },
                        { type: 'NumberInput', key: 'discount', col: '4', information: { label: '{{lang}}discount', placeholder: '{{lang}}discount', required: true }, showMain: true, },
                        { type: 'NumberInput', key: 'deposit', col: '4', information: { label: '{{lang}}deposit', placeholder: '{{lang}}deposit', required: true }, showMain: true, },
                    ],

                    placeholder: '{{lang}}country discount',
                    required: false,
                },
                showMain: true
            },
            {
                type: 'SubformInput',
                key: 'floorPrice',
                col: '12',
                information: {
                    label: 'countries discount and deposit',
                    headers: [
                        { type: 'SelectInput', key: 'country', col: '4', information: { label: '{{lang}}country', placeholder: '{{lang}}country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, showMain: true, fullCol: true },
                        { type: 'NumberInput', key: 'daily', col: '2', information: { label: 'Daily Floor Price', placeholder: 'Daily Floor Price', required: true }, showMain: true, },
                        { type: 'NumberInput', key: 'weekly', col: '3', information: { label: 'Weekly Floor Price', placeholder: 'Weekly Floor Price', required: true }, showMain: true, },
                        { type: 'NumberInput', key: 'monthly', col: '3', information: { label: 'Monthly Floor Price', placeholder: 'Monthly Floor Price', required: true }, showMain: true, },
                    ],

                    placeholder: '{{lang}}country discount',
                    required: false,
                },
                showMain: true
            },
            // { type: 'NumberInput', key: 'floorPrice.daily', col: '6', information: { label: 'Daily Floor Price', }, showMain: false },
            // { type: 'NumberInput', key: 'floorPrice.weekly', col: '6', information: { label: 'Weekly Floor Price', }, showMain: false },
            // { type: 'NumberInput', key: 'floorPrice.monthly', col: '6', information: { label: 'Monthly Floor Price', }, showMain: false },
            { key: 'onlyFor', type: 'SelectInput', col: '6', information: { label: 'Use Only In', placeholder: 'Select ...', type: 'local', items: [{ title: "Rental", value: '0' }, { title: 'Buy / Sell', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },
            { type: 'AdvancedSelectInput', key: 'highLightedSpec', col: '6', information: { isSearchable: true, label: 'High Lighted Specification', type: 'api', fields: { value: '_id', title: 'name', description: "nameDesc" }, address: 'getAttributes', filter: { country: '{{country}}' } }, settings: { required: false }, showMain: true, fullCol: true, inExport: true },
            {
                type: 'SubformInput',
                key: 'highLightedSpecs',
                col: '12',
                information: {
                    label: 'High Lighted Specification',
                    headers: [

                        { type: 'AdvancedSelectInput', key: 'specification', col: '4', information: { isSearchable: true, label: 'High Lighted Specification', type: 'api', fields: { value: '_id', title: 'name', description: "nameDesc" }, address: 'getAttributes', filter: { country: '{{country}}' } }, settings: { required: false }, showMain: true, fullCol: true, inExport: true },
                        { key: 'name', type: 'TextInput', showMain: true, col: '4', information: { label: 'Name' }, },
                        { key: 'min', type: 'NumberInput', col: '3', information: { label: 'min', }, },
                        { key: 'max', type: 'NumberInput', col: '3', information: { label: 'max', }, },
                        { type: 'SwitchInput', key: 'active', col: '2', information: { label: 'Active', inExport: false }, showMain: false },
                        { type: 'SwitchInput', key: 'showRange', col: '2', information: { label: 'Show Range', inExport: false }, showMain: false },],

                    placeholder: '{{lang}}country discount',
                    required: false,
                },

                showMain: false
            },
            //////// hideInList
            { type: 'NumberInput', key: 'count', col: '6', information: { label: 'Count', }, showMain: true, hideInList: true, inExport: true },
            { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'Parent', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: '{{country}}' } }, settings: { required: false }, showMain: true, fullCol: true, inExport: true },
            { type: 'SelectInput', key: 'InsuranceType', col: '6', information: { label: '{{lang}}Insurance Type', placeholder: '{{lang}}insurance type', type: 'local', items: [{ title: "Without Insurance", value: 'withoutInsurance' }, { title: 'Equipment Insurance', value: 'equipmentInsurance' }, { title: 'Vehicle Insurance', value: 'vehicleInsurance' },], required: false }, showMain: false },
            { type: 'MultiSelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: false },
            { key: 'activeBrand', col: '6', type: 'SelectInput', information: { label: 'Active Brand', type: 'local', items: [{ title: "Required", value: 'required' }, { title: "Not Required", value: 'notRequired' }, { title: "Don't Have", value: 'notHave' },] }, settings: { required: false }, showMain: true },
            { key: 'activeModel', col: '6', type: 'SelectInput', information: { label: 'Active Model', type: 'local', items: [{ title: "Required", value: 'required' }, { title: "Not Required", value: 'notRequired' }, { title: "Don't Have", value: 'notHave' },] }, settings: { required: false }, showMain: true },
            { key: 'activeYear', col: '6', type: 'SelectInput', information: { label: 'Active Year', type: 'local', items: [{ title: "Required", value: 'required' }, { title: "Not Required", value: 'notRequired' }, { title: "Don't Have", value: 'notHave' },] }, settings: { required: false }, showMain: true },
            { key: 'activeSN', col: '6', type: 'SelectInput', information: { label: 'Active Serial Number', type: 'local', items: [{ title: "Required", value: 'required' }, { title: "Not Required", value: 'notRequired' }, { title: "Don't Have", value: 'notHave' },] }, settings: { required: false }, showMain: true },
            // { type: 'SwitchInput', key: 'hasBrandNew', showMain: true, col: '6', information: { label: 'Has Brand New', inExport: false } },

            { key: 'description', type: 'EditorInput', col: '12', information: { label: 'Description', }, showMain: false, inExport: false, hasTranslation: true },
            { key: 'MaDescription', type: 'EditorInput', col: '12', information: { label: 'Malasia Description', }, showMain: false, inExport: false, hasTranslation: true },
            { key: 'SellDescription', type: 'EditorInput', col: '12', information: { label: 'Buy / Sell Description', }, showMain: false, inExport: false, hasTranslation: true },
            { type: 'SwitchInput', key: 'withOperator', showMain: true, col: '6', information: { label: 'with operator', inExport: false } },
            { type: 'SwitchInput', key: 'withoutInsurance', col: '6', information: { label: 'Without Insurance', inExport: false }, showMain: false },

            { type: 'EditorInput', key: 'body', information: { label: 'Body', }, showMain: false, fullCol: true, hasTranslation: true },
            { type: 'EditorInput', key: 'sellBody', information: { label: 'Sell Body', }, showMain: false, fullCol: true, hasTranslation: true },

            { key: 'deactive', type: 'SwitchInput', col: '6', information: { label: 'Deactive', }, showMain: true, },
            // { col: '6', key: 'inHomePage', type: 'SelectInput', information: { label: '{{lang}}in HomePage', placeholder: '{{lang}}be in homePage?', type: 'local', items: [{ title: "Yes", value: true }, { title: 'No', value: false },], required: false }, showMain: false },
            { type: 'MultiSelectInput', key: 'inHomePageCountry', col: '6', information: { label: 'in HomePage Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: false },
            { key: 'flexible', type: 'SwitchInput', col: '6', information: { label: 'Flexible', }, showMain: false, },
            { key: 'sellHomePageCountry', type: 'SwitchInput', col: '6', information: { label: 'In Sell HomePage', }, showMain: false, },
            { key: 'grid', type: 'SwitchInput', col: '6', information: { label: 'Grid View', }, showMain: false, },
            { type: 'SwitchInput', key: 'meterhours', col: '6', information: { label: 'Meter Hours', default: true, inExport: false }, showMain: false },
            { type: 'SwitchInput', key: 'hasYear', col: '6', information: { label: 'Has Year', default: true, inExport: false }, showMain: false },


            // { key: 'values.isSearchable', type: 'SwitchInput', col: '6', information: { label: 'Is searchable', }, showMain: true, },
            // { title: 'Edit', type: 'button', function: 'edit', options: { color: "#78b2d0" }, showMain: true }, { title: 'Remove', type: 'button', function: 'remove', options: { color: "#dd8aa4" }, showMain: true }
        ],
    },




    ////////  reqequipments
    ////////  breakdowns



    users: {
        key: 'users',
        title: 'Users Listing',
        description: 'Users List',
        fetchUrl: 'getUsers',
        addUrl: 'addUser',
        editUrl: 'addUser',
        fetchOne: 'getOneUser',
        removeUrl: 'removeUser',
        pageType: 'form',
        // page: 'partners',
        parent: 'main',
        populate: ["country", 'presentor'],
        addNew: -1,
        options: { noAddNew: true },
        sort: { date: -1 },
        extra: { export: { url: 'userExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },
            aiBilling: { key: "aiBilling", label: 'AI Billing', color: '#20a878', function: "openAiBillingModal", permission: 'view' },
            // PDF: { key: "PDF", label: '{{lang}}Download Insurance PDF', color: '#677dc4', function: "downloadInsurancePDF", permission: 'view' },
            dedidatePlan: { key: "dedidatePlan", label: '{{lang}}Dedicate Plan', color: '#677dc4', function: "dedidatePlan", permission: 'edit' },
            dedidatePlanWithLink: { key: "dedidatePlanWithLink", label: '{{lang}}Dedicate Plan With Payment Link', color: '#677dc4', function: "dedidatePlanWithLink", permission: 'edit' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        // postBody:{country:'*'},
        // postBody: { active: 0 },
        postBody: {
         type:{$ne:'anonymous'}
        },
        // Lists default to Antbuildz accounts (the API applies `owner: null`).
        // "Webstore customers" asks for storefront-realm accounts; the API enforces the partition.
        defaultTabTitle: 'Antbuildz',
        tabs: [

            { title: 'Partners', filter: { "status": '2' } },
            { title: 'Webstore customers', filter: { realm: 'webstore' } },
            // { title: 'subscriptions', filter: { 'siteName': { $ne: null, $exists: true } } },
        ],

        image: '/images/covers/subThings.jpg',
        headers: [

            // { col: '6', key: 'siteName', type: 'TextInput', information: { label: 'Web Store Domain', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'webstoreName', type: 'TextInput', information: { label: 'Web Store Name', disabled: false, required: false }, showMain: true, inExport: true },
          
            { type: 'TextInput', key: 'company', col: '6', information: { label: 'Company', }, showMain: true, inExport: true },
            { type: 'DateInput', key: 'date', col: '6', information: { label: 'Register Date', }, showMain: true, hideInList: true, inExport: true },

            { key: 'userId', type: 'TextInput', showMain: true, col: '6', information: { label: 'User Id', disabled: false }, inExport: true },

            { key: 'nature', type: 'MultiSelectInput', col: '6', information: { label: 'Business segment', type: 'local', items: [{ title: 'Oil and gas', value: "O&G" }, { title: 'Marine construction', value: "Marine" }, { title: 'Building construction', value: "Building" }, { title: 'Maintenance', value: "maintenance" }, { title: 'Facilities Management', value: "management" }, { title: 'Logistic', value: "logistic" }, { title: 'Rental House', value: "rental" }, { title: 'Warehousing', value: "warehousing" }, { title: 'Other', value: "Other" }] }, settings: { required: true }, showMain: false, inExport: false },

            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true, inExport: true },
            {
                type: 'SelectInput', key: 'cityLoc', information: { label: 'City', placeholder: 'City ...', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: {}, required: false },
                dependencies: [{
                    refKey: 'country',
                    targetKey: 'cityLoc',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } }
                            }
                        }
                    },
                    show: false,
                    init: false,
                    changeHeader: { key: 'information.filter.country', value: '@data.country' },
                    //  changeValue: {
                    //         targetKey: "city",
                    //         value: null,
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.country' }, operator: { value: '!=' }, target: { value: null } }
                    //                 }
                    //             },
                    //         },
                    //     }
                }],
                showMain: true
            },
            { key: 'presentor', type: 'SelectInput', col: '6', information: { label: 'Key Account', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getEmployees', filter: {} }, showMain: true, inExport: true },

            { type: 'TextInput', key: 'email', col: '6', information: { label: 'Email', }, showMain: true,disabled:true, inExport: true },

            { type: 'TextInput', key: 'ccemail', col: '6', information: { label: 'CC Email', }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'cc2email', col: '6', information: { label: 'CC2 Email', }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'cc3email', col: '6', information: { label: 'CC3 Email', }, showMain: false, inExport: true },

            { type: 'TextInput', key: 'phone', col: '6', information: { label: 'Phone Number', }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'name', col: '6', information: { label: 'Name', }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'uen', col: '6', information: { label: 'UEN', }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'position', col: '6', information: { label: 'Position', }, showMain: true, inExport: true },

            { type: 'TextInput', key: 'bank', col: '6', information: { label: 'Bank Name', }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'account', col: '6', information: { label: 'Bank Account', }, showMain: false, inExport: true },
            // { type: 'TextInput', key: 'description', col: '6', information: { label: 'Description', }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'address', col: '6', information: { label: 'Office Address', }, showMain: false, inExport: true },

            { type: 'TextAreaInput', key: 'description', col: '6', information: { label: 'Description', }, showMain: false, inExport: true },
            // { key: 'recognition', type: 'SelectInput', information: { label: translate('How Did You Heard About Us'), type: 'local', items: [{ title: translate('Linkedin'), value: "Linkedin" }, { title: translate('Facebook'), value: "Facebook" }, { title: translate('Instagram'), value: "Instagram" }, { title: translate('TikTok'), value: "TikTok" }, { title: translate('Email'), value: "Email" }, { title: translate('Search Engine'), value: "Search Engine" }, { title: translate('Referral by others'), value: "Referral by others" }, { title: translate('Other (Request to list out)'), value: "Other" }], placeholder: translate('How Did You Heard About Us'), required: true } },
            { key: 'recognition', type: 'SelectInput', col: '6', information: { label: 'How Did You Heard About Us', type: 'local', default: '0', items: [{ title: 'Linkedin', value: "Linkedin" }, { title: 'Facebook', value: "Facebook" }, { title: 'Instagram', value: "Instagram" }, { title: 'TikTok', value: "TikTok" }, { title: 'Email', value: "Email" }, { title: 'Search Engine', value: "Search Engine", value2: 'SearchEngine' }, { title: 'Referral by others', value: "Referral by others", value2: 'Referralbyothers' }, { title: 'Other (Request to list out)', value: "Other" }] }, settings: { required: true }, showMain: true, inExport: true },
            {
                key: 'otherDescription', type: 'TextAreaInput', col: '12', information: { label: 'Describe more', updateAfterSelect: true, isSearchable: false, },
                dependencies: [{
                    refKey: 'recognition',
                    targetKey: 'otherDescription',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.recognition' }, operator: { value: '==' }, target: { value: 'Other' } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                }],
                showMain: false, inExport: true
            },
            { type: 'PasswordInput', key: 'password', col: '6', information: { label: 'Password', }, showMain: false },

            { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "User", value: "0" }, { title: 'Pending Partner ...', value: "1" }, { title: 'Partner', value: 2 }] }, settings: { required: true }, showMain: true, inExport: true },
            // { key: 'rating', type: 'SelectInput', col: '6', information: { label: 'rating', type: 'local', default: '0', items: [{ title: "0", value: 0 }, { title: "0.5", value: 0.5 }, { title: "1", value: 1 }, { title: "1.5", value: 1.5 }, { title: "2", value: 2 }, { title: "2.5", value: 2.5 }, { title: "3", value: 3 }, { title: "3.5", value: 3.5 }, { title: "4", value: 4 }, { title: "4.5", value: 4.5 }, { title: "5", value: 5 },] }, settings: { required: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'rating', col: '6', information: { label: 'Rating', }, showMain: true, inExport: true },

            { key: 'verified', type: 'SwitchInput', col: '6', information: { label: 'Verified', }, showMain: false, },
            { key: 'blocked', type: 'SwitchInput', col: '6', information: { label: 'Blocked', }, showMain: false, },

            { key: 'date', type: 'DateInput', col: '6', information: { label: 'Register Date', }, showMain: false, inExport: true },
            { type: 'BooleanInput', key: 'downloadedPDF', col: '6', information: { label: 'Downloaded Ebook', }, showMain: true, inExport: true },
            { key: 'downloadDate', type: 'DateInput', col: '6', information: { label: 'Ebook Download Date', }, showMain: true, inExport: true },
            { type: 'SwitchInput', key: 'showSubscriber', col: '6', information: { label: 'Show As Subscriber', }, showMain: false },
            { key: 'screenShots', type: 'FileInput', col: '12', information: { label: 'Attached Screen Shots', single: false }, showMain: false, fullCol: true, settings: { required: false }, },


            // { key: 'subscriptionStatus', type: 'SelectInput', col: '6', information: { label: 'Subscription Status', placeholder: 'Select ...', type: 'local', items: [{ title: "Not Subscribed", value: 0 }, { title: 'Subscribed', value: 1 }, { title: 'Canceled By Antbuildz', value: -1 }] }, showMain: true },
            // subs
            // { key: 'subscriptionStartDate', type: 'DateInput', col: '6', information: { label: 'Subscription Start Date', }, showMain: true, inExport: true },
            // { col: '6', key: 'siteName', type: 'TextInput', information: { label: 'Web Store Domain', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'webstoreName', type: 'TextInput', information: { label: 'Web Store Name', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '12', key: 'siteLogo', type: 'ImageInput', information: { label: 'Logo', disabled: false, single: true, required: false }, showMain: true, inExport: true },
            // { key: 'subscriptionOnlyFor', type: 'MultiSelectInput', col: '6', information: { showAllInTable: true, label: 'Use Only In (0 for Rental and 1 for Sale)', placeholder: 'Select ...', type: 'local', items: [{ title: "Rental", value: '0' }, { title: 'Buy / Sell', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },
            // { key: 'userId', type: 'TextInput', showMain: true, col: '6', information: { label: 'User Id', disabled: false }, inExport: true },

            // // { type: 'NumberInput', key: 'MarketplaceLisitng', col: '6', information: { label: 'Marketplace Lisitng', }, showMain: true },
            // { type: 'NumberInput', key: 'WebStoreListing', col: '6', information: { label: 'Web Store Listing', }, showMain: true },

            // { type: 'TextInput', key: 'email', col: '6', information: { label: 'Email', }, showMain: true, inExport: true },

            // { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: false },

            // { type: 'TextInput', key: 'phone', col: '6', information: { label: 'Phone Number', }, showMain: false, inExport: true },
            // { type: 'TextInput', key: 'name', col: '6', information: { label: 'Name', }, showMain: true, inExport: true },
            // // { type: 'TextInput', key: 'uen', col: '6', information: { label: 'UEN', }, showMain: true, inExport: true },
            // { type: 'TextInput', key: 'position', col: '6', information: { label: 'Position', }, showMain: true, inExport: true },


            // { type: 'TextInput', key: 'address', col: '6', information: { label: 'Office Address', }, showMain: false, inExport: true },


            // { key: 'subscriptionStatus', type: 'SelectInput', col: '6', information: { label: 'Subscription Status', placeholder: 'Select ...', type: 'local', items: [{ title: "Not Subscribed", value: 0 }, { title: 'Subscribed', value: 1 }, { title: 'Canceled By Antbuildz', value: -1 }] }, showMain: true },

            // { type: 'SwitchInput', key: 'delayedPayment', col: '6', information: { label: 'Delayed Payment', }, showMain: false },
            // { key: 'whatsAppDirect', type: 'PhoneInput', col: '6', information: { label: "Whatsapp Direct Number", placeholder: '22222222', required: false } },
            // { col: '6', type: 'SelectInput', key: 'defaultHomePage', information: { label: 'Default Home Page', placeholder: 'Select ...', type: 'local', default: 'rental', items: [{ title: "Rental", value: 'rental' }, { title: 'Buy / Sell', value: 'sell' }] }, showMain: true, inExport: true },
            // { key: 'primaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Primary Color', disabled: false, required: false }, showMain: false, inExport: true },
            // { key: 'secondaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Secondary Color', disabled: false, required: false }, showMain: false, inExport: true },
            // { key: 'showWebName', type: 'SwitchInput', col: '6', information: { label: 'Show Web Store Name In Header', }, showMain: false, },
            // { key: 'isCanceledSubscription', type: 'SwitchInput', col: '6', information: { label: 'Subscription Canceled Buy Partner', }, showMain: false, },
            // { key: 'showInWebSlider', type: 'SwitchInput', col: '6', information: { label: 'Show In Web Store Page Slider', }, showMain: false, },
            // // { key: 'subscriptionPlan', type: 'SelectInput', col: '6', information: { label: 'Subscription Plan', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getEmployees', filter: {} }, showMain: true },

            // { key: 'subscriptionPlan', type: 'SelectInput', col: '6', information: { label: 'Subscription Plan', type: 'api', fields: { value: '_id', title: 'name', description: 'description' }, address: 'getSubscriptionPlans', filter: {} }, showMain: true },
            // { key: 'voucherId', type: 'SelectInput', col: '6', information: { label: 'Used Voucher', type: 'api', fields: { value: '_id', title: 'voucherId' }, address: 'getVouchersSubscription', filter: {} }, showMain: false },
            // { key: 'subscriptionDate', type: 'DateInput', col: '6', information: { label: 'Subscription Date', }, showMain: true, inExport: true },
            // { key: 'recurationPeriod', type: 'SelectInput', col: '6', information: { label: 'Recuration Period', placeholder: 'Select ...', type: 'local', items: [{ title: "Monthly", value: "month" }, { title: "Annually", value: "year" }] }, showMain: true },

            // { key: 'recuringDate', type: 'DateInput', col: '6', information: { label: 'Recuring Date', }, showMain: false, inExport: true },
            // { key: 'deactivationDate', type: 'DateInput', col: '6', information: { label: 'Deactivation Date', }, showMain: false, inExport: true },
            // { col: '6', key: 'stripeCustomerId', type: 'TextInput', information: { label: 'Stripe Customer Id', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'currentSubscriptionId', type: 'TextInput', information: { label: 'Current Subscription Id', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'currentPaymentMethodId', type: 'TextInput', information: { label: 'Current Payment Method Id', disabled: false, required: false }, showMain: true, inExport: true },


        ],
    },


    usersSubscriptions: {
        key: 'usersSubscriptions',
        title: 'Web Store Subscribers',
        description: 'Web Store Subscribers List',
        fetchUrl: 'getUsers',
        addUrl: 'addUser',
        editUrl: 'addUser',
        fetchOne: 'getOneAdminWebStoreSubscriber',
        removeUrl: 'removeUser',
        pageType: 'form',
        // page: 'partners',
        parent: 'main',

        addNew: -1,
        options: { noAddNew: true },
        sort: { subscriptionStartDate: -1 },
        extra: { export: { url: 'userExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },
            aiBilling: { key: "aiBilling", label: 'AI Billing', color: '#20a878', function: "openAiBillingModal", permission: 'view' },
            // // PDF: { key: "PDF", label: '{{lang}}Download Insurance PDF', color: '#677dc4', function: "downloadInsurancePDF", permission: 'view' },
            // dedidatePlan: { key: "dedidatePlan", label: '{{lang}}Dedicate Plan', color: '#677dc4', function: "dedidatePlan", permission: 'edit' },
            // dedidatePlanWithLink: { key: "dedidatePlanWithLink", label: '{{lang}}Dedicate Plan With Payment Link', color: '#677dc4', function: "dedidatePlanWithLink", permission: 'edit' },
            // remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        // postBody:{country:'*'},
        // postBody: { subscriptionStatus: 1 },
        postBody: {
            $or: [
                { subscriptionStatus: 1 },
                { showSubscriber: true }
            ]
        },

        image: '/images/covers/subThings.jpg',
        headers: [
            // { type: 'TextInput', key: 'company', col: '6', information: { label: 'Company', }, showMain: true, inExport: true },
            { key: '_id', type: 'SelectInput', col: '6', information: { self: true, label: 'User', type: 'api', fields: { value: '_id', title: 'company', description: 'name' }, address: 'getUsers', filter: { country: "{{country}}", status: 2 }, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: true, showInfilter: true, inExport: true },

            // { type: 'DateInput', key: 'date', col: '6', information: { label: 'Register Date', }, showMain: true, hideInList: true, inExport: true },

            { key: 'subscriptionStartDate', type: 'DateInput', col: '6', information: { label: 'Subscription Start Date', }, showMain: true, inExport: true },
            { col: '6', type: 'SelectInput', key: 'subStatus', information: { label: 'Subscription Status', placeholder: 'Select ...', type: 'local', default: 'Subscribed', items: [{ title: "Active", value: 'Subscribed' }, { title: 'Canceling', value: 'Canceled' }, { title: 'Deleted', value: 'Deleted' }, { title: 'Payment Failed', value: 'PaymentFail' }] }, showMain: true, inExport: true },
            { col: '6', key: 'siteName', type: 'TextInput', information: { label: 'Web Store Domain', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'customDomain', type: 'TextInput', information: { label: 'Custom Domain', disabled: false, required: false }, showMain: true, inExport: true },

            { key: 'presentorSub', type: 'SelectInput', col: '6', information: { label: 'Key Account', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getEmployees', filter: {} }, showMain: true },

            { col: '6', key: 'webstoreName', type: 'TextInput', information: { label: 'Web Store Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '12', key: 'siteLogo', type: 'ImageInput', information: { label: 'Logo', disabled: false, single: true, required: false }, showMain: true, inExport: true },
            { key: 'subscriptionOnlyFor', type: 'MultiSelectInput', col: '6', information: { showAllInTable: true, label: 'Use Only In (0 for Rental and 1 for Sale)', placeholder: 'Select ...', type: 'local', items: [{ title: "Rental", value: '0' }, { title: 'Buy / Sell', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'userId', type: 'TextInput', showMain: true, col: '6', information: { label: 'User Id', disabled: false }, inExport: true },

            // { type: 'NumberInput', key: 'MarketplaceLisitng', col: '6', information: { label: 'Marketplace Lisitng', }, showMain: true },
            { type: 'NumberInput', key: 'WebStoreListing', col: '6', information: { label: 'Web Store Listing', }, showMain: true },
            { type: 'TextInput', key: 'aiPlanDisplayName', col: '6', information: { label: 'AI Plan Name (snapshot)', disabled: true }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'aiCreditsIncluded', col: '6', information: { label: 'AI Credits Included (snapshot)', disabled: true }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'aiPlaygroundPromptsIncluded', col: '6', information: { label: 'AI Playground Prompts (snapshot)', disabled: true }, showMain: false, inExport: true },
            { type: 'NumberInput', key: 'aiKnowledgeStorageMb', col: '6', information: { label: 'AI Knowledge Storage MB (snapshot)', disabled: true }, showMain: false, inExport: true },
            { type: 'SwitchInput', key: 'aiTopUpsEnabled', col: '6', information: { label: 'AI Top-ups Enabled (snapshot)', disabled: true }, showMain: false, inExport: true },
            { type: 'NumberInput', key: 'aiTenantCount', col: '6', information: { label: 'Connected AI Tenants', disabled: true, hint: 'Number of AI workspaces owned by this subscriber.' }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'aiTenantId', col: '6', information: { label: 'AI Tenant ID (live)', disabled: true }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'aiTenantName', col: '6', information: { label: 'AI Tenant Name (live)', disabled: true }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'aiTenantDomain', col: '6', information: { label: 'AI Tenant Domain (live)', disabled: true }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'aiRemainingCredits', col: '6', information: { label: 'Remaining AI Credits (live)', disabled: true, hint: 'Current metered balance, including the monthly 100,000-credit allowance when Free Credits is enabled.' }, showMain: false, inExport: true },
            { type: 'NumberInput', key: 'aiIncludedCreditsLive', col: '6', information: { label: 'Included AI Credits (live)', disabled: true }, showMain: false, inExport: true },
            { type: 'NumberInput', key: 'aiUsedCreditsLive', col: '6', information: { label: 'Used AI Credits (live)', disabled: true }, showMain: false, inExport: true },
            { type: 'NumberInput', key: 'aiTopUpCreditsLive', col: '6', information: { label: 'Top-up AI Credits (live)', disabled: true }, showMain: false, inExport: true },
            { type: 'SwitchInput', key: 'aiFreeCredits', col: '6', information: { label: 'Free Credits (live)', disabled: true }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'aiBillingServiceStatus', col: '12', information: { label: 'AI Billing Service Status', disabled: true }, showMain: false, inExport: true },

            { type: 'TextInput', key: 'email', col: '6', information: { label: 'Email', }, showMain: true, inExport: true },

            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: false },

            { type: 'TextInput', key: 'phone', col: '6', information: { label: 'Phone Number', }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'name', col: '6', information: { label: 'Name', }, showMain: true, inExport: true },
            // { type: 'TextInput', key: 'uen', col: '6', information: { label: 'UEN', }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'position', col: '6', information: { label: 'Position', }, showMain: true, inExport: true },


            { type: 'TextInput', key: 'address', col: '6', information: { label: 'Office Address', }, showMain: false, inExport: true },


            { key: 'subscriptionStatus', type: 'SelectInput', col: '6', information: { label: 'Subscription Activision', placeholder: 'Select ...', type: 'local', items: [{ title: "Not Subscribed", value: 0 }, { title: 'Subscribed', value: 1 }, { title: 'Canceled By Antbuildz', value: -1 }] }, showMain: true },
            
            { type: 'SwitchInput', key: 'delayedPayment', col: '6', information: { label: 'Delayed Payment', }, showMain: false },
            { key: 'whatsAppDirect', type: 'PhoneInput', col: '6', information: { label: "Whatsapp Direct Number", placeholder: '22222222', required: false } },
            { col: '6', type: 'SelectInput', key: 'defaultHomePage', information: { label: 'Default Home Page', placeholder: 'Select ...', type: 'local', default: 'rental', items: [{ title: "Rental", value: 'rental' }, { title: 'Buy / Sell', value: 'sell' }] }, showMain: true, inExport: true },
            { key: 'primaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Primary Color', disabled: false, required: false }, showMain: false, inExport: true },
            { key: 'secondaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Secondary Color', disabled: false, required: false }, showMain: false, inExport: true },
            { key: 'showWebName', type: 'SwitchInput', col: '6', information: { label: 'Show Web Store Name In Header', }, showMain: false, },
            { key: 'isCanceledSubscription', type: 'SwitchInput', col: '6', information: { label: 'Subscription Canceled Buy Partner', }, showMain: false, },
            { key: 'showInWebSlider', type: 'SwitchInput', col: '6', information: { label: 'Show In Web Store Page Slider', }, showMain: false, },
            // { key: 'subscriptionPlan', type: 'SelectInput', col: '6', information: { label: 'Subscription Plan', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getEmployees', filter: {} }, showMain: true },
            
            { key: 'subscriptionPlan', type: 'SelectInput', col: '6', information: { label: 'Subscription Plan', type: 'api', fields: { value: '_id', title: 'name', description: 'description' }, address: 'getSubscriptionPlans', filter: {} }, showMain: true },
            { key: 'voucherId', type: 'SelectInput', col: '6', information: { label: 'Used Voucher', type: 'api', fields: { value: '_id', title: 'voucherId' }, address: 'getVouchersSubscription', filter: {} }, showMain: false },
            { key: 'subscriptionDate', type: 'DateInput', col: '6', information: { label: 'Subscription Date', }, showMain: true, inExport: true },
            { key: 'recurationPeriod', type: 'SelectInput', col: '6', information: { label: 'Recuration Period', placeholder: 'Select ...', type: 'local', items: [{ title: "Monthly", value: "month" }, { title: "Annually", value: "year" }] }, showMain: true },
            
            { key: 'recuringDate', type: 'DateInput', col: '6', information: { label: 'Recuring Date', }, showMain: false, inExport: true },
            { key: 'deactivationDate', type: 'DateInput', col: '6', information: { label: 'Deactivation Date', }, showMain: false, inExport: true },
            { col: '6', key: 'stripeCustomerId', type: 'TextInput', information: { label: 'Stripe Customer Id', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'currentSubscriptionId', type: 'TextInput', information: { label: 'Current Subscription Id', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'currentPaymentMethodId', type: 'TextInput', information: { label: 'Current Payment Method Id', disabled: false, required: false }, showMain: true, inExport: true },
            { type: 'SwitchInput', key: 'showSubscriber', col: '6', information: { label: 'Show As Subscriber', }, showMain: false },
            { type: 'SwitchInput', key: 'hideInSite', col: '6', information: { label: 'Hide IN Website', }, showMain: false },
            { key: 'customDomainStatus', type: 'SelectInput', col: '6', information: { label: 'Domain Status', placeholder: 'Select ...', type: 'local', items: [{ title: "active", value: "active" },{ title: "pending", value: "pending" },{ title: "failed", value: "failed" },{ title: "removed", value: "removed" }] }, showMain: true },
            // { key: 'date', type: 'DateInput', col: '6', information: { label: 'Register Date', }, showMain: false, inExport: true },


        ],
    },
    tenants: {
        key: 'tenants',
        title: 'Tenants',
        description: 'Workspaces (storefront + AI). Transfer ownership from the owner field.',
        fetchUrl: 'getTenants',
        addUrl: 'transferTenant',
        editUrl: 'transferTenant',
        fetchOne: 'getOneTenant',
        pageType: 'form',
        parent: 'main',
        addNew: -1,
        options: { noAddNew: true },
        sort: { createdAt: -1 },
        extra: {
            runPostDeployMigrations: {
                name: 'Run post-deploy tenant migrations',
                description: 'Run tenant, billing, content, search, user-realm and duplicate-agent migrations in order.',
                function: 'openPostDeployMigrations',
                icon: '/images/add.svg',
            },
            consolidateStorefrontRoutes: {
                name: 'Restore subscriber Worker routes',
                description: 'Create and verify one separate Cloudflare Worker route for every subscriber Web Store Domain.',
                function: 'openStorefrontRouteConsolidation',
                icon: '/images/settings.svg',
            },
        },
        actions: {
            edit: { key: "edit", label: 'Transfer owner', color: '#677dc4', function: "openEditModal", permission: 'edit' },
        },
        image: '/images/covers/subThings.jpg',
        headers: [
            { key: 'name', type: 'TextInput', col: '6', information: { label: 'Workspace', disabled: true }, showMain: true },
            { key: 'domain', type: 'TextInput', col: '6', information: { label: 'Storefront subdomain', disabled: true }, showMain: true },
            { key: 'customDomain', type: 'TextInput', col: '6', information: { label: 'Custom domain', disabled: true }, showMain: true },
            { key: 'status', type: 'TextInput', col: '6', information: { label: 'Status', disabled: true }, showMain: true },
            { key: 'workspaceKind', type: 'TextInput', col: '6', information: { label: 'Kind', disabled: true }, showMain: true },
            { key: 'owner', type: 'SelectInput', col: '6', information: { label: 'Owner (save to transfer)', type: 'api', fields: { value: '_id', title: 'company', description: 'email' }, address: 'getUsers', filter: {} }, showMain: true },
            { key: 'billingAccount', type: 'TextInput', col: '6', information: { label: 'Billing account', disabled: true }, showMain: true },
            { key: '_id', type: 'TextInput', col: '6', information: { label: 'Tenant Id', disabled: true }, showMain: true },
        ],
    },
    aiBillingTenants: {
        key: 'aiBillingTenants',
        title: 'AI Tenants',
        description: 'Tenant AI credit balances, subscriptions, and billing exemptions',
        fetchUrl: 'getAdminAiBillingTenantList',
        editUrl: 'updateAdminAiBillingTenant',
        fetchOne: 'getOneAdminAiBillingTenant',
        // removeUrl: 'removeAdminAiBillingTenantList',
        pageType: 'form',
        parent: 'main',
        addNew: -1,
        options: { noAddNew: true },
        sort: { createdAt: -1 },
        image: '/images/covers/subThings.jpg',
        extra: {
            setHeadStartCredits: {
                name: 'Set Head Start credits',
                description: 'Set every tenant to exactly 100 usable AI credits, clear top-ups, and disable Free Credits.',
                function: 'openBulkAiCreditGrant',
                icon: '/images/add.svg',
            },
        },
        actions: {
            edit: { key: 'edit', label: '{{lang}}edit', color: '#677dc4', function: 'openEditModal', permission: 'edit' },
        },
        headers: [
            { type: 'TextInput', key: '_id', col: '6', information: { label: 'Tenant ID', disabled: true }, showMain: true, showInfilter: true, inExport: true },
            { type: 'TextInput', key: 'tenantName', col: '6', information: { label: 'Tenant Name', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'ownerCompany', col: '6', information: { label: 'Owner Company', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'ownerName', col: '6', information: { label: 'Owner Name', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'ownerEmail', col: '6', information: { label: 'Owner Email', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'domain', col: '6', information: { label: 'Web Store Domain', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'customDomain', col: '6', information: { label: 'Custom Domain', disabled: true }, showMain: false, inExport: true },
            { type: 'TextInput', key: 'planName', col: '6', information: { label: 'AI Plan', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'subscriptionStatus', col: '6', information: { label: 'Subscription Status', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'remainingCredits', col: '6', information: { label: 'Remaining AI Credits', disabled: true, hint: 'Live metered balance. Free Credits refills this allowance to 100,000 each calendar month.' }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'includedCredits', col: '6', information: { label: 'Included Credits', disabled: true }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'usedCredits', col: '6', information: { label: 'Used Credits', disabled: true }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'reservedCredits', col: '6', information: { label: 'Reserved Credits', disabled: true }, showMain: false, inExport: true },
            { type: 'NumberInput', key: 'topUpCredits', col: '6', information: { label: 'Top-up Credits', disabled: true }, showMain: true, inExport: true },
            { type: 'SwitchInput', key: 'freeCredits', col: '6', information: { label: 'Free Credits', default: false, hint: 'When enabled, usage is still charged normally against a 100,000-credit allowance that refills every calendar month.' }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'billingError', col: '12', information: { label: 'Billing Service Status', disabled: true }, showMain: false, inExport: true },
        ],
    },
    subscriptionPlan: {
        key: 'subscriptionPlan',
        title: 'Web Store Plans',
        description: 'Web Store Plans List',
        fetchUrl: 'getSubscriptionPlans',
        addUrl: 'addSubscriptionPlan',
        editUrl: 'addSubscriptionPlan',
        // fetchOne: 'getOneUser',
        removeUrl: 'removeSubscriptionPlan',
        pageType: 'form',
        // page: 'partners',
        parent: 'main',

        // addNew: -1,
        // options: { noAddNew: true },
        sort: { cDate: -1 },
        actions: {
            edit: { key: 'edit', label: '{{lang}}edit', color: '#677dc4', function: 'openEditModal', permission: 'edit' },
            publishTest: { key: 'publishTest', label: 'Publish TEST checkout', color: '#2563eb', function: 'publishSubscriptionPlanTest', permission: 'edit' },
            publishLive: { key: 'publishLive', label: 'Publish LIVE checkout', color: '#d97706', function: 'publishSubscriptionPlanLive', permission: 'edit' },
            remove: { key: 'remove', label: '{{lang}}remove', color: '#ee5050', function: 'openRemoveModal', permission: 'delete' },
        },
        extra: {
            publishAiPlans: {
                name: 'Review and publish AI website plans',
                description: 'Separate USD plan publication after Stripe price review; does not run tenant migrations.',
                function: 'openAiWebsitePublication',
                icon: '/images/eye.svg',
            },
        },

        // postBody:{country:'*'},
        // postBody: { active: 0 },
        tabs: [

            // { title: 'Partners', filter: { "status": '2' } },
            // { title: 'Refunds', filter: { "type": 'Refund' } },
        ],

        image: '/images/covers/subThings.jpg',
        headers: [









            { type: 'TextInput', key: 'name', col: '6', information: { label: 'title' }, showMain: true, inExport: true },
            websiteField('websites'),
            { key: 'checkoutMode', type: 'SelectInput', col: '6', information: { label: 'Checkout Mode', placeholder: 'Keep legacy behaviour', type: 'local', items: [{ title: 'Self-service checkout', value: 'self_service' }, { title: 'Contact sales', value: 'contact_sales' }], hint: 'For subscription plans only. Leave blank to retain historical behaviour.' }, showMain: false },
            { key: 'subscriptionAITType', type: 'MultiSelectInput', col: '6', information: { showAllInTable: true, label: 'Plan Product', placeholder: 'Select the plan product ...', type: 'local', items: [{ title: 'AI Agent Only', value: 'AI' }, { title: 'Webstore + AI', value: 'Webstore' }], hint: 'Choose Webstore + AI for every Webstore plan. Choose AI Agent Only only when the plan does not include a Webstore.' }, settings: { required: true }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'aiCreditsIncluded', col: '6', information: { label: 'AI Credits Included', default: 0, hint: 'Required for both Webstore + AI and AI Agent Only plans.' }, settings: { min: 0 }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'aiPlaygroundPromptsIncluded', col: '6', information: { label: 'AI Playground Prompts Included', default: 0, hint: 'Required for both Webstore + AI and AI Agent Only plans.' }, settings: { min: 0 }, showMain: false, inExport: true },
            { type: 'NumberInput', key: 'aiKnowledgeStorageMb', col: '6', information: { label: 'AI Knowledge Storage (MB)', default: 0, hint: 'Required for both Webstore + AI and AI Agent Only plans.' }, settings: { min: 0 }, showMain: false, inExport: true },
            { type: 'SwitchInput', key: 'aiTopUpsEnabled', col: '6', information: { label: 'Allow AI Credit Top-ups', default: false }, showMain: true, inExport: true },
            { key: 'aiCreditResetPeriod', type: 'SelectInput', col: '6', information: { label: 'AI Allowance Reset', placeholder: 'Keep legacy billing-period reset', type: 'local', items: [{ title: 'Monthly, including annual subscriptions', value: 'month' }, { title: 'Each billing period (legacy)', value: 'billing_period' }] }, showMain: true },
            { type: 'NumberInput', key: 'equipmentListingLimit', col: '6', information: { label: 'Combined Sales + Rental Listing Limit', hint: 'Leave empty to retain legacy per-type limits. Zero disables listings. New Rental+ uses 300 combined.' }, showMain: true, inExport: true },
            { key: 'subscriptionType', type: 'SelectInput', col: '6', information: { label: 'Subscription Type', placeholder: 'Select ...', type: 'local', items: [{ title: "Start Up", value: 'Start Up' }, { title: "Basic", value: 'Basic' }, { title: 'Premium', value: 'Premium' }, { title: 'Enterprise', value: 'Enterprise' }] }, showMain: true },
            { key: 'paymentType', type: 'SelectInput', col: '6', information: { label: 'Payment Type', placeholder: 'Select ...', type: 'local', items: [{ title: "recuring", value: '1' }, { title: 'One Time Payment', value: '2' }] }, showMain: true },
            // { type: 'NumberInput', key: 'duration', col: '6', information: { label: 'Duration In Days', }, showMain: true },
            // { type: 'NumberInput', key: 'recuration', col: '6', information: { label: 'Every', }, showMain: true },
            { key: 'recurationPeriod', type: 'SelectInput', col: '6', information: { label: 'Recuration Period', placeholder: 'Select ...', type: 'local', items: [{ title: "Monthly", value: "month" }, { title: "Annually", value: "year" }] }, showMain: true },
            { key: 'planType', type: 'SelectInput', col: '6', information: { label: 'Plan Type', placeholder: 'Select ...', type: 'local', items: [{ title: "General", value: "General" }, { title: "Specified", value: "Specified" }] }, showMain: true },

            // { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: { filter: {  } } }, settings: { required: false }, showMain: true, required: true },
            // { key: 'price', type: 'PriceInput', col: '6', information: { label: 'Amount', }, showMain: true, inExport: true },
            { key: 'onlyFor', type: 'MultiSelectInput', col: '6', information: { showAllInTable: true, label: 'Use Only In (0 for Rental and 1 for Sell)', placeholder: 'Select ...', type: 'local', items: [{ title: "Rental", value: '0' }, { title: 'Buy / Sell', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },
            {
                type: 'SubformInput',
                key: 'price',
                col: '12',
                information: {
                    label: 'Prices List',
                    headers: [
                        { type: 'SelectInput', key: 'country', col: '3', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: { filter: {} } }, settings: { required: false } },
                        { key: 'currency', type: 'SelectInput', col: '2', information: { label: 'Currency', default: 'USD', type: 'local', isSearchable: true, items: [{ title: 'USD — US Dollar', value: 'USD' }, { title: 'SGD — Singapore Dollar', value: 'SGD' }, { title: 'AUD — Australian Dollar', value: 'AUD' }, { title: 'EUR — Euro', value: 'EUR' }, { title: 'GBP — British Pound', value: 'GBP' }, { title: 'MYR — Malaysian Ringgit', value: 'MYR' }] } },
                        { key: 'priceBeforeDiscount', type: 'PriceInput', col: '2', information: { label: 'Price Before Discount', }, },
                        { key: 'priceAfterDiscount', type: 'PriceInput', col: '2', information: { label: 'Price After Discount', }, },
                        { key: 'stripeId', type: 'TextInput', showMain: true, col: '3', information: { label: 'stripeId' }, },
                        { key: 'title', type: 'TextInput', showMain: true, col: '4', information: { label: 'Title' }, },
                        { key: 'description', type: 'TextInput', showMain: true, col: '6', information: { label: 'Description' }, },
                        // { type: 'SelectInput', key: 'country', col: '4', information: { label: 'country', placeholder: '{{lang}}country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, showMain: true, fullCol: true },
                    ],

                    placeholder: '{{lang}}country discount',
                    required: false,
                },

                showMain: false
            },
            {
                type: 'SubformInput',
                key: 'features',
                col: '12',
                information: {
                    label: 'Features List',
                    headers: [
                        { key: 'feature', type: 'TextInput', showMain: true, col: '7', information: { label: 'Feature Name' }, },
                        { key: 'icon', type: 'ImageInput', col: '5', information: { label: 'Icon', single: true, cropper: false }, showMain: true, fullCol: true },

                        // { type: 'SelectInput', key: 'country', col: '4', information: { label: 'country', placeholder: '{{lang}}country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, showMain: true, fullCol: true },
                    ],

                    placeholder: '{{lang}}country discount',
                    required: false,
                },

                showMain: false
            },
            { key: 'bestValue', type: 'SwitchInput', col: '6', information: { label: 'Popular For Growth', }, showMain: false, },
            { key: 'comingSoon', type: 'SwitchInput', col: '6', information: { label: 'Coming Soon', default: false, hint: 'This switch does not publish checkout. The approved USD plan and Stripe price must be published separately before customers can subscribe.' }, showMain: true, inExport: true },

            // { type: 'NumberInput', key: 'MarketplaceLisitng', col: '6', information: { label: 'Marketplace Lisitng', }, showMain: true },
            { type: 'NumberInput', key: 'WebStoreListing', col: '6', information: { label: 'Rental Web Store Listing', }, showMain: true },
            { type: 'NumberInput', key: 'WebStoreListingBuy', col: '6', information: { label: 'Sales Web Store Listing', }, showMain: true },
            { type: 'NumberInput', key: 'trialDays', col: '6', information: { label: 'Trial Days', }, showMain: true },
            // { key: 'stripeId', type: 'TextInput', showMain: true, col: '6', information: { label: 'stripeId'}, inExport: true },
            // { key: 'type', type: 'TextInput', showMain: true, col: '6', information: { label: 'type', disabled: true }, inExport: true },
            { type: 'TextAreaInput', key: 'description', information: { label: 'description', }, showMain: true },
            { key: 'image', type: 'ImageInput', col: '12', information: { label: 'Image', single: true, cropper: false }, showMain: true, fullCol: true },






        ],
    },
    additinalCreditsPlan: {
        key: 'additinalCreditsPlan',
        title: 'Additional AI Credit Plans',
        description: 'Purchasable AI credit packages',
        fetchUrl: 'getAdditinalCreditsPlans',
        addUrl: 'addAdditinalCreditsPlan',
        editUrl: 'addAdditinalCreditsPlan',
        fetchOne: 'getOneAdditinalCreditsPlan',
        removeUrl: 'removeAdditinalCreditsPlan',
        pageType: 'form',
        parent: 'main',
        sort: { sortOrder: 1, credits: 1 },
        image: '/images/covers/subThings.jpg',
        headers: [
            { type: 'TextInput', key: 'packageCode', col: '6', information: { label: 'Package Code', placeholder: 'credits_25', required: true, hint: 'This code cannot be changed after the package is created.' }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'label', col: '6', information: { label: 'Display Label', placeholder: '25 AI credits', required: true }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'credits', col: '6', information: { label: 'AI Credits', placeholder: '25', required: true }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'sortOrder', col: '6', information: { label: 'Display Order', placeholder: '0', default: 0 }, showMain: true, inExport: true },
            { type: 'PriceInput', key: 'prices.USD', col: '6', information: { label: 'Price (USD)', placeholder: '29.00', required: true }, showMain: true, inExport: true },
            { type: 'PriceInput', key: 'prices.SGD', col: '6', information: { label: 'Price (SGD)', placeholder: '39.00', required: true }, showMain: true, inExport: true },
            { type: 'SwitchInput', key: 'active', col: '6', information: { label: 'Available For Purchase', default: true }, showMain: true, inExport: true },
            { type: 'TextAreaInput', key: 'description', col: '12', information: { label: 'Description', placeholder: 'Describe this credit package.' }, showMain: false, inExport: true },
            {
                type: 'SubformInput',
                key: 'features',
                col: '12',
                information: {
                    label: 'Features List',
                    headers: [
                        { key: 'feature', type: 'TextInput', showMain: true, col: '7', information: { label: 'Feature Name' }, },
                        { key: 'icon', type: 'ImageInput', col: '5', information: { label: 'Icon', single: true, cropper: false }, showMain: true, fullCol: true },
                    ],
                    placeholder: 'Add a package feature',
                    required: false,
                },
                showMain: false
            },
        ],
    },
    additionalEquipmentPlan: {
        key: 'additionalEquipmentPlan',
        title: 'Additional Equipment Capacity Plans',
        description: 'Purchasable AI recurring equipment capacity',
        fetchUrl: 'getAdditionalEquipmentPlans',
        addUrl: 'addAdditionalEquipmentPlan',
        editUrl: 'addAdditionalEquipmentPlan',
        fetchOne: 'getOneAdditionalEquipmentPlan',
        removeUrl: 'removeAdditionalEquipmentPlan',
        pageType: 'form',
        extra: {
            importUsdDrafts: {
                name: 'Import USD equipment drafts',
                description: 'Preview and add missing inactive monthly and annual equipment offers. Existing plans are preserved.',
                function: 'importUsdEquipmentDrafts',
                icon: '/images/eye.svg',
            },
        },
        parent: 'main',
        sort: { sortOrder: 1, equipment: 1 },
        image: '/images/covers/subThings.jpg',
        headers: [
            { type: 'TextInput', key: 'packageCode', col: '6', information: { label: 'Package Code', placeholder: 'equipment_25', required: true, hint: 'This code cannot be changed after the package is created.' }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'label', col: '6', information: { label: 'Display Label', placeholder: 'Additional equipment capacity', required: true }, showMain: true, inExport: true },
            { key: 'recurationPeriod', type: 'SelectInput', col: '6', information: { label: 'Recurring Billing Period', type: 'local', items: [{ title: 'Monthly', value: 'month' }, { title: 'Annual', value: 'year' }], required: true, hint: 'Use a separate package for each billing period. The period cannot change after creation.' }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'equipment', col: '6', information: { label: 'Equipment Slots Per Unit', placeholder: '25', required: true }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'sortOrder', col: '6', information: { label: 'Display Order', placeholder: '0', default: 0 }, showMain: true, inExport: true },
            { type: 'PriceInput', key: 'prices.USD', col: '6', information: { label: 'USD Per Unit Per Billing Period', placeholder: '29.00', required: true }, showMain: true, inExport: true },
            { type: 'SwitchInput', key: 'active', col: '6', information: { label: 'Available For Purchase', default: false }, showMain: true, inExport: true },
            { type: 'TextAreaInput', key: 'description', col: '12', information: { label: 'Description', placeholder: 'Describe this recurring equipment package.' }, showMain: false, inExport: true },
            {
                type: 'SubformInput',
                key: 'features',
                col: '12',
                information: {
                    label: 'Features List',
                    headers: [
                        { key: 'feature', type: 'TextInput', showMain: true, col: '7', information: { label: 'Feature Name' }, },
                        { key: 'icon', type: 'ImageInput', col: '5', information: { label: 'Icon', single: true, cropper: false }, showMain: true, fullCol: true },
                    ],
                    placeholder: 'Add a package feature',
                    required: false,
                },
                showMain: false
            },
        ],
    },
    subscription: {
        key: 'subscription',
        title: 'Web Store Requests',
        description: 'Web Store Requests List',
        fetchUrl: 'getSubscriptions',
        // fetchOne: 'getOneUser',
        pageType: 'form',
        // page: 'partners',
        parent: 'main',

        addNew: -1,
        sort: { cDate: -1 },
        // extra: { export: { url: 'userExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

        // postBody:{country:'*'},
        // postBody: { active: 0 },
        actions: {
            // PDF: { key: "PDF", label: '{{lang}}Download Insurance PDF', color: '#677dc4', function: "downloadInsurancePDF", permission: 'view' },
            dedidatePlan: { key: "dedidatePlan", label: '{{lang}}Dedicate Plan', color: '#677dc4', function: "dedidatePlan", permission: 'edit' },
            dedidatePlanWithLink: { key: "dedidatePlanWithLink", label: '{{lang}}Dedicate Plan With Payment Link', color: '#677dc4', function: "dedidatePlanWithLink", permission: 'edit' },
        },
        tabs: [

            // { title: 'Partners', filter: { "status": '2' } },
            { title: 'Enterprise Subscription', filter: { 'subscriptionType': "Enterprise" } },
        ],

        image: '/images/covers/subThings.jpg',
        headers: [





            { key: 'user', type: 'SelectInput', col: '6', information: { label: 'User', type: 'api', fields: { value: '_id', title: 'company', description: 'name' }, address: 'getUsers', filter: { country: "{{country}}", status: 2 }, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: true, showInfilter: true, inExport: true },

            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Register Date', }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'sessionId', col: '6', information: { label: 'Session Id' }, showMain: true, inExport: true },


            // { key: 'subscriptionStatus', type: 'SwitchInput', col: '6', information: { label: 'Subscription Status', }, showMain: false, },
            { key: 'subscriptionStatus', type: 'SelectInput', col: '6', information: { label: 'Subscription Status', placeholder: 'Select ...', type: 'local', items: [{ title: "Not Validate", value: 0 }, { title: 'Validate', value: 1 }, { title: 'Canceled', value: -1 }] }, showMain: true },
            { key: 'paymentStatus', type: 'SelectInput', col: '6', information: { label: 'Payment Status', placeholder: 'Select ...', type: 'local', items: [{ title: "Not Done", value: 0 }, { title: 'Done', value: 1 }] }, showMain: true },
            { key: 'subscriptionType', type: 'SelectInput', col: '6', information: { label: 'Subscription Type', placeholder: 'Select ...', type: 'local', items: [{ title: "type1", value: '1' }, { title: 'type2', value: '2' }] }, showMain: true },
            { key: 'paymentType', type: 'SelectInput', col: '6', information: { label: 'Payment Type', placeholder: 'Select ...', type: 'local', items: [{ title: "recuring", value: '1' }, { title: 'normal', value: '2' }] }, showMain: true },
            { type: 'NumberInput', key: 'duration', col: '6', information: { label: 'Duration In Days', }, showMain: true },
            { type: 'NumberInput', key: 'recuration', col: '6', information: { label: 'Recuring Period In Days', }, showMain: true },
            { key: 'subscriptionPlan', type: 'SelectInput', col: '6', information: { label: 'Subscription Plan', type: 'api', fields: { value: '_id', title: 'name', description: 'description' }, address: 'getSubscriptionPlans', filter: {} }, showMain: true },

            { key: 'onlyFor', type: 'MultiSelectInput', col: '6', information: { label: 'Use Only In', placeholder: 'Select ...', type: 'local', items: [{ title: "Rental", value: '0' }, { title: 'Buy / Sell', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },

            { col: '12', key: 'siteLogo', type: 'ImageInput', information: { label: 'Logo', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'webstoreName', type: 'TextInput', information: { label: 'Web Store Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'subscriptionId', type: 'TextInput', information: { label: 'Subscription Id', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'currentPaymentMethodId', type: 'TextInput', information: { label: 'Current Payment Method Id', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'siteName', type: 'TextInput', information: { label: 'Web Store Domain', disabled: false, required: false }, showMain: true, inExport: true },
            { key: 'primaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Primary Color', disabled: false, required: false }, showMain: true, inExport: true },
            { key: 'secondaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Secondary Color', disabled: false, required: false }, showMain: true, inExport: true },
            { key: 'showWebName', type: 'SwitchInput', col: '6', information: { label: 'Show Web Store Name In Header', }, showMain: false, },
            { col: '6', key: 'contact.name', type: 'TextInput', information: { label: 'Contact Name', disabled: false, required: false }, showMain: true, inExport: true },
            { key: 'contact.phone', type: 'PhoneInput', col: '6', information: { label: "Contact Whatsapp Number", placeholder: '22222222', required: false } },
            { type: 'TextAreaInput', key: 'contact.description', information: { label: 'Description', }, showMain: true },


            { key: 'recuringDate', type: 'DateInput', col: '6', information: { label: 'Recuring Date', }, showMain: false, inExport: true },
            { key: 'deactivationDate', type: 'DateInput', col: '6', information: { label: 'Deactivation Date', }, showMain: false, inExport: true },





        ],
    },
    paymentHistory: {
        key: 'paymentHistory',
        title: 'Payment History',
        description: 'Payment History',
        fetchUrl: 'getPaymentHistories',
        addUrl: 'addPaymentHistory',
        editUrl: 'addPaymentHistory',
        // fetchOne: 'getOneUser',
        removeUrl: 'removePaymentHistory',
        pageType: 'form',
        // page: 'partners',
        parent: 'main',

        // addNew: -1,
        // options: { noAddNew: true },
        sort: { cDate: -1 },
        // extra: { export: { url: 'userExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

        // postBody:{country:'*'},
        // postBody: { active: 0 },
        // actions: {
        //     edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },
        //     // PDF: { key: "PDF", label: '{{lang}}Download Insurance PDF', color: '#677dc4', function: "downloadInsurancePDF", permission: 'view' },
        //     dedidatePlan: { key: "dedidatePlan", label: '{{lang}}Dedicate Plan', color: '#677dc4', function: "dedidatePlan", permission: 'edit' },
        //     dedidatePlanWithLink: { key: "dedidatePlanWithLink", label: '{{lang}}Dedicate Plan With Payment Link', color: '#677dc4', function: "dedidatePlanWithLink", permission: 'edit' },
        //     remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        // },
        // tabs: [

        //     // { title: 'Partners', filter: { "status": '2' } },
        //     { title: 'Enterprise Subscription', filter: { 'subscriptionType': "Enterprise" } },
        // ],

        image: '/images/covers/subThings.jpg',
        headers: [





            { key: 'user', type: 'SelectInput', col: '6', information: { label: 'User', type: 'api', fields: { value: '_id', title: 'name', description: 'company' }, address: 'getUsers', filter: { country: "{{country}}", status: 2 }, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: true, showInfilter: true, inExport: true },

            { type: 'TextInput', key: 'user.company', col: '6', information: { label: 'Company', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'user.email', col: '6', information: { label: 'Email', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'uniquid', col: '6', information: { label: 'Unique Id', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'paymentId', col: '6', information: { label: 'Payment Id', disabled: true }, showMain: true, inExport: true },
            { key: 'paymentType', type: 'SelectInput', col: '6', information: { label: 'Payment Type', placeholder: 'Select ...', type: 'local', items: [{ title: "Cash", value: 'cash' }, { title: 'Stripe', value: 'stripe' }] }, showMain: true },
            { type: 'NumberInput', key: 'amount', col: '6', information: { label: 'Amount', }, showMain: true },
            { type: 'TextInput', key: 'currency', col: '6', information: { label: 'Currency', disabled: false }, showMain: true, inExport: true },



            // // { key: 'subscriptionStatus', type: 'SwitchInput', col: '6', information: { label: 'Subscription Status', }, showMain: false, },
            // { key: 'subscriptionStatus', type: 'SelectInput', col: '6', information: { label: 'Subscription Status', placeholder: 'Select ...', type: 'local', items: [{ title: "Not Validate", value: 0 }, { title: 'Validate', value: 1 }, { title: 'Canceled', value: -1 }] }, showMain: true },
            // { key: 'paymentStatus', type: 'SelectInput', col: '6', information: { label: 'Payment Status', placeholder: 'Select ...', type: 'local', items: [{ title: "Not Done", value: 0 }, { title: 'Done', value: 1 }] }, showMain: true },
            // { key: 'subscriptionType', type: 'SelectInput', col: '6', information: { label: 'Subscription Type', placeholder: 'Select ...', type: 'local', items: [{ title: "type1", value: '1' }, { title: 'type2', value: '2' }] }, showMain: true },
            // { key: 'paymentType', type: 'SelectInput', col: '6', information: { label: 'Payment Type', placeholder: 'Select ...', type: 'local', items: [{ title: "recuring", value: '1' }, { title: 'normal', value: '2' }] }, showMain: true },
            // { type: 'NumberInput', key: 'duration', col: '6', information: { label: 'Duration In Days', }, showMain: true },
            // { type: 'NumberInput', key: 'recuration', col: '6', information: { label: 'Recuring Period In Days', }, showMain: true },
            // { key: 'onlyFor', type: 'MultiSelectInput', col: '6', information: { label: 'Use Only In', placeholder: 'Select ...', type: 'local', items: [{ title: "Rental", value: '0' }, { title: 'Buy / Sell', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },

            // { col: '12', key: 'siteLogo', type: 'ImageInput', information: { label: 'Logo', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'webstoreName', type: 'TextInput', information: { label: 'Web Store Name', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'subscriptionId', type: 'TextInput', information: { label: 'Subscription Id', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'currentPaymentMethodId', type: 'TextInput', information: { label: 'Current Payment Method Id', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'siteName', type: 'TextInput', information: { label: 'Web Store Domain', disabled: false, required: false }, showMain: true, inExport: true },
            // { key: 'primaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Primary Color', disabled: false, required: false }, showMain: true, inExport: true },
            // { key: 'secondaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Secondary Color', disabled: false, required: false }, showMain: true, inExport: true },
            // { key: 'showWebName', type: 'SwitchInput', col: '6', information: { label: 'Show Web Store Name In Header', }, showMain: false, },


            // { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Register Date', }, showMain: false, inExport: true },
            // { key: 'recuringDate', type: 'DateInput', col: '6', information: { label: 'Recuring Date', }, showMain: false, inExport: true },
            // { key: 'deactivationDate', type: 'DateInput', col: '6', information: { label: 'Deactivation Date', }, showMain: false, inExport: true },





        ],
    },
    paymentInvoces: {
        key: 'paymentInvoices',
        title: 'Payment Invoices',
        description: 'Payment Invoices',
        fetchUrl: 'getPaymentInvoices',
        addUrl: 'addPaymentInvoices',
        editUrl: 'addPaymentInvoices',
        // fetchOne: 'getOneUser',
        removeUrl: 'removePaymentInvoices',
        pageType: 'form',
        // page: 'partners',
        parent: 'main',

        // addNew: -1,
        // options: { noAddNew: true },
        sort: { cDate: -1 },
        // extra: { export: { url: 'userExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

        // postBody:{country:'*'},
        // postBody: { active: 0 },
        // actions: {
        //     edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },
        //     // PDF: { key: "PDF", label: '{{lang}}Download Insurance PDF', color: '#677dc4', function: "downloadInsurancePDF", permission: 'view' },
        //     dedidatePlan: { key: "dedidatePlan", label: '{{lang}}Dedicate Plan', color: '#677dc4', function: "dedidatePlan", permission: 'edit' },
        //     dedidatePlanWithLink: { key: "dedidatePlanWithLink", label: '{{lang}}Dedicate Plan With Payment Link', color: '#677dc4', function: "dedidatePlanWithLink", permission: 'edit' },
        //     remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        // },
        // tabs: [

        //     // { title: 'Partners', filter: { "status": '2' } },
        //     { title: 'Enterprise Subscription', filter: { 'subscriptionType': "Enterprise" } },
        // ],

        image: '/images/covers/subThings.jpg',
        headers: [





            { key: 'subscriptionPlan', type: 'SelectInput', col: '6', information: { label: 'Subscription Plan', type: 'api', fields: { value: '_id', title: 'name', description: 'description' }, address: 'getSubscriptionPlans', filter: {} }, showMain: true },
            { key: 'user', type: 'SelectInput', col: '6', information: { label: 'User', type: 'api', fields: { value: '_id', title: 'company', description: 'name' }, address: 'getUsers', filter: { country: "{{country}}", status: 2 }, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: true, showInfilter: true, inExport: true },

            { type: 'TextInput', key: 'uniquid', col: '6', information: { label: 'Unique Id', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'invoiceId', col: '6', information: { label: 'Invoice Id', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'description', col: '6', information: { label: 'description', disabled: false }, showMain: true, inExport: true },
            { key: 'paymentType', type: 'SelectInput', col: '6', information: { label: 'Payment Type', placeholder: 'Select ...', type: 'local', items: [{ title: "Cash", value: 'cash' }, { title: 'Stripe', value: 'stripe' }] }, showMain: true },
            { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', placeholder: 'Select ...', type: 'local', items: [{ title: "Paid", value: 'paid' }, { title: 'Open', value: 'open' }] }, showMain: true },
            { type: 'NumberInput', key: 'amount_paid', col: '6', information: { label: 'Amount Paid', }, showMain: true },
            { type: 'NumberInput', key: 'subtotal', col: '6', information: { label: 'Subtotal', }, showMain: true },
            { type: 'NumberInput', key: 'tax', col: '6', information: { label: 'Tax', }, showMain: true },
            { type: 'NumberInput', key: 'discount', col: '6', information: { label: 'Discount', }, showMain: true },
            { type: 'TextInput', key: 'currency', col: '6', information: { label: 'Currency', disabled: false }, showMain: true, inExport: true },
            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Payment Date', }, showMain: true, inExport: true },
            { key: 'period_start', type: 'DateInput', col: '6', information: { label: 'Start Date', }, showMain: true, inExport: true },
            { key: 'period_end', type: 'DateInput', col: '6', information: { label: 'End Date', }, showMain: true, inExport: true },



            // // { key: 'subscriptionStatus', type: 'SwitchInput', col: '6', information: { label: 'Subscription Status', }, showMain: false, },
            // { key: 'subscriptionStatus', type: 'SelectInput', col: '6', information: { label: 'Subscription Status', placeholder: 'Select ...', type: 'local', items: [{ title: "Not Validate", value: 0 }, { title: 'Validate', value: 1 }, { title: 'Canceled', value: -1 }] }, showMain: true },
            // { key: 'paymentStatus', type: 'SelectInput', col: '6', information: { label: 'Payment Status', placeholder: 'Select ...', type: 'local', items: [{ title: "Not Done", value: 0 }, { title: 'Done', value: 1 }] }, showMain: true },
            // { key: 'subscriptionType', type: 'SelectInput', col: '6', information: { label: 'Subscription Type', placeholder: 'Select ...', type: 'local', items: [{ title: "type1", value: '1' }, { title: 'type2', value: '2' }] }, showMain: true },
            // { key: 'paymentType', type: 'SelectInput', col: '6', information: { label: 'Payment Type', placeholder: 'Select ...', type: 'local', items: [{ title: "recuring", value: '1' }, { title: 'normal', value: '2' }] }, showMain: true },
            // { type: 'NumberInput', key: 'duration', col: '6', information: { label: 'Duration In Days', }, showMain: true },
            // { type: 'NumberInput', key: 'recuration', col: '6', information: { label: 'Recuring Period In Days', }, showMain: true },
            // { key: 'onlyFor', type: 'MultiSelectInput', col: '6', information: { label: 'Use Only In', placeholder: 'Select ...', type: 'local', items: [{ title: "Rental", value: '0' }, { title: 'Buy / Sell', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },

            // { col: '12', key: 'siteLogo', type: 'ImageInput', information: { label: 'Logo', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'webstoreName', type: 'TextInput', information: { label: 'Web Store Name', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'subscriptionId', type: 'TextInput', information: { label: 'Subscription Id', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'currentPaymentMethodId', type: 'TextInput', information: { label: 'Current Payment Method Id', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'siteName', type: 'TextInput', information: { label: 'Web Store Domain', disabled: false, required: false }, showMain: true, inExport: true },
            // { key: 'primaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Primary Color', disabled: false, required: false }, showMain: true, inExport: true },
            // { key: 'secondaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Secondary Color', disabled: false, required: false }, showMain: true, inExport: true },
            // { key: 'showWebName', type: 'SwitchInput', col: '6', information: { label: 'Show Web Store Name In Header', }, showMain: false, },


            // { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Register Date', }, showMain: false, inExport: true },
            // { key: 'recuringDate', type: 'DateInput', col: '6', information: { label: 'Recuring Date', }, showMain: false, inExport: true },
            // { key: 'deactivationDate', type: 'DateInput', col: '6', information: { label: 'Deactivation Date', }, showMain: false, inExport: true },





        ],
    },
    // views: {
    //     key: 'views',
    //     title: 'Views Listing',
    //     description: 'Views List',
    //     fetchUrl: 'viewsGetAll',
    //     // addUrl: 'setemail',
    //     // editUrl: 'setemail',
    //     // // fetchOne: 'getOneUser',
    //     // removeUrl: 'removeemail',
    //     pageType: 'form',
    //     // page: 'partners',
    //     parent: 'admin',

    //     addNew: -1,
    //     options: { noAddNew: true },
    //     sort: { cDate: -1 },
    //     // extra: { export: { url: 'userExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

    //     // postBody:{country:'*'},
    //     // postBody: { active: 0 },
    //     additionaldata:{
    //         key:'totals.0',
    //         headers: [
    //             { col: '3', type: 'NumberInput', key: 'allViewsTotal', showMain: true, information: { label: ("{{lang}}All Views "), required: true, desc: '{{lang}}total' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsMonthly', showMain: true, information: { label: ("{{lang}}All Views This Month"), required: true, desc: '{{lang}}current month' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsWithVisitorTotal', showMain: true, information: { label: ("{{lang}}All Logged In Views"), required: true, desc: '{{lang}}total' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsWithVisitorMonthly', showMain: true, information: { label: ("{{lang}}All Logged In Views This Month"), required: true, desc: '{{lang}}current month' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsWithWebStoreTotal', showMain: true, information: { label: ("{{lang}}All Webstore Views"), required: true, desc: '{{lang}}total' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsWithWebStoreMonthly', showMain: true, information: { label: ("{{lang}}All Webstore Views This Month"), required: true, desc: '{{lang}}current month' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsWithWebStoreAndVisitorTotal', showMain: true, information: { label: ("{{lang}}all Logged In Webstore Views "), required: true, desc: '{{lang}}total' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsWithWebStoreAndVisitorMonthly', showMain: true, information: { label: ("{{lang}}all Logged In Webstore Views This Month"), required: true, desc: '{{lang}}current month' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsWithoutWebStoreTotal', showMain: true, information: { label: ("{{lang}}All Non Webstore Views"), required: true, desc: '{{lang}}total' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsWithoutWebStoreMonthly', showMain: true, information: { label: ("{{lang}}All  Non Webstore  Views This Month"), required: true, desc: '{{lang}}current month' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsWithoutWebStoreWithVisitorTotal', showMain: true, information: { label: ("{{lang}}All Logged In Non Webstore Views"), required: true, desc: '{{lang}}total' }, showMain: true, },
    //             { col: '3', type: 'NumberInput', key: 'allViewsWithoutWebStoreWithVisitorMonthly', showMain: true, information: { label: ("{{lang}}All Logged In Non Webstore Views This Month"), required: true, desc: '{{lang}}current month' }, showMain: true, },

    //         ],
    //     },
    //     tabs: [

    //         // { title: 'Partners', filter: { "status": '2' } },
    //         // { title: 'Refunds', filter: { "type": 'Refund' } },
    //     ],

    //     image: '/images/covers/subThings.jpg',
    //     headers: [
    //         { col: '6', type: 'TextInput', key: 'address', showMain: true, information: { label: ("{{lang}}address"), required: true }, showMain: true, },
    //         { col: '6', type: 'TextInput', key: 'totalCount', showMain: true, information: { label: ("{{lang}}total Count"), required: true }, showMain: true, },
    //         { col: '6', type: 'TextInput', key: 'monthlyCount', showMain: true, information: { label: ("{{lang}}monthly Count"), required: true }, showMain: true, },
    //         { col: '6', type: 'TextInput', key: 'category', showMain: true, information: { label: ("{{lang}}category"), required: true }, showMain: true, },
    //         // { col: '6', type: 'TextInput', key: 'siteAddress', showMain: true, information: { label: ("{{lang}}siteAddress"), required: true }, showMain: true, },
    //         // { key: 'visitor', type: 'SelectInput', col: '6', information: { label: 'user', type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: {}, disabled: true }, showMain: true },
    //         { key: 'webStore', type: 'SelectInput', col: '6', information: { label: 'Webstore', type: 'api', fields: { value: '_id', title: 'siteName' }, address: 'getUsers', filter: {}, disabled: true }, showMain: true },
    //         // { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true } },


    //     ],
    // },
    emails: {
        key: 'emails',
        title: 'Emails Listing',
        description: 'Emails List',
        fetchUrl: 'getAllEmail',
        addUrl: 'setemail',
        editUrl: 'setemail',
        // fetchOne: 'getOneUser',
        removeUrl: 'removeemail',
        pageType: 'form',
        // page: 'partners',
        parent: 'admin',

        addNew: -1,
        options: { noAddNew: true },
        sort: { cDate: -1 },
        // extra: { export: { url: 'userExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

        // postBody:{country:'*'},
        // postBody: { active: 0 },
        tabs: [

            // { title: 'Partners', filter: { "status": '2' } },
            // { title: 'Refunds', filter: { "type": 'Refund' } },
        ],

        image: '/images/covers/subThings.jpg',
        headers: [









            { type: 'TextInput', key: 'title', col: '6', information: { label: 'title', disabled: true }, showMain: true, inExport: true },
            { type: 'DateInput', key: 'cDate', col: '6', information: { label: ' Date', disabled: true, time: true }, showMain: true, inExport: true },

            { key: 'type', type: 'TextInput', showMain: true, col: '6', information: { label: 'type', disabled: true }, inExport: true },
            { key: 'from', type: 'TextInput', showMain: true, col: '6', information: { label: 'from', disabled: true }, inExport: true },
            { key: 'to', type: 'TextInput', showMain: true, col: '6', information: { label: 'to', disabled: true }, inExport: true },
            { key: 'body', type: 'EditorInput', showMain: true, col: '6', information: { label: 'to', disabled: true }, inExport: true },


            { key: 'user', type: 'SelectInput', col: '6', information: { label: 'user', type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: {}, disabled: true }, showMain: true },




        ],
    },
    loggers: {
        key: 'loggers',
        title: 'Loggers Listing',
        description: 'loggers List',
        fetchUrl: 'getAllLogger',
        addUrl: 'setemail',
        editUrl: 'setemail',
        // fetchOne: 'getOneUser',
        removeUrl: 'removeemail',
        pageType: 'form',
        // page: 'partners',
        parent: 'admin',

        addNew: -1,
        options: { noAddNew: true },
        sort: { cDate: -1 },
        // extra: { export: { url: 'userExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

        // postBody:{country:'*'},
        // postBody: { active: 0 },
        tabs: [

            // { title: 'Partners', filter: { "status": '2' } },
            // { title: 'Refunds', filter: { "type": 'Refund' } },
        ],

        image: '/images/covers/subThings.jpg',
        headers: [









            { type: 'TextInput', key: 'title', col: '6', information: { label: 'title', disabled: true }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'status', col: '6', information: { label: 'status', disabled: true }, showMain: true, inExport: true },
            { type: 'DateInput', key: 'cDate', col: '6', information: { label: ' Date', disabled: true, time: true }, showMain: true, inExport: true },

            { key: 'type', type: 'TextInput', showMain: true, col: '6', information: { label: 'type', disabled: true }, inExport: true },
            { key: 'from', type: 'TextInput', showMain: true, col: '6', information: { label: 'from', disabled: true }, inExport: true },
            { key: 'to', type: 'TextInput', showMain: true, col: '6', information: { label: 'to', disabled: true }, inExport: true },
            { key: 'body', type: 'EditorInput', showMain: true, col: '6', information: { label: 'to', disabled: true }, inExport: true },


            { key: 'user', type: 'SelectInput', col: '6', information: { label: 'user', type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: {}, disabled: true }, showMain: true },




        ],
    },






    // partners: {
    //     key: 'partners',
    //     title: 'partners',
    //     description: 'AntBuilz partners',
    //     fetchUrl: 'getUsers',
    //     addFetch: 'addUser',
    //     removeUrl: 'removeUser',
    //     pageType: 'form',
    //     page: 'partners',
    //     parent: 'main',

    //     addNew: -1,
    //     options: { noAddNew: true },

    //     postBody: { "status": 1 },
    //     image: '/images/covers/applets.jpg',
    //     headers: [

    //         { key: 'userId', type: 'TextInput', showMain: true, col: '6', information: { label: 'User Id', disabled: true } },
    //         { key: 'values.status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', items: [{ title: "User", value: "0" }, { title: 'Pending Partner ...', value: "1" }, { title: 'Partner', value: 2 }] }, settings: { required: true }, showMain: true },

    //         { type: 'TextInput', key: 'values.company', col: '6', information: { label: 'Company', }, showMain: true },

    //         { key: 'values.nature', type: 'MultiselectInput', col: '6', information: { label: 'Business segment', type: 'local', items: [{ title: 'Oil and gas', value: "O&G" }, { title: 'Marine construction', value: "Marine" }, { title: 'Building construction', value: "Building" }, { title: 'Maintenance', value: "maintenance" }, { title: 'Facilities Management', value: "management" }, { title: 'Logistic', value: "logistic" }, { title: 'Rental House', value: "rental" }, { title: 'Warehousing', value: "warehousing" }, { title: 'Other', value: "Other" }] }, settings: { required: true }, showMain: false },

    //         { type: 'TextInput', key: 'values.email', col: '6', information: { label: 'Email', }, showMain: true },
    //         { type: 'PasswordInput', key: 'values.password', col: '6', information: { label: 'Password', }, showMain: false },
    //         { type: 'TextInput', key: 'values.phone', col: '6', information: { label: 'Phone Number', }, showMain: false },
    //         { type: 'TextInput', key: 'values.name', col: '6', information: { label: 'Name', }, showMain: false },
    //         { type: 'TextInput', key: 'values.uen', col: '6', information: { label: 'UEN', }, showMain: false },
    //         { type: 'TextInput', key: 'values.position', col: '6', information: { label: 'Position', }, showMain: false },

    //         { type: 'TextInput', key: 'values.bank', col: '6', information: { label: 'Bank Name', }, showMain: false },
    //         { type: 'TextInput', key: 'values.account', col: '6', information: { label: 'Bank Account', }, showMain: false },
    //         { type: 'TextInput', key: 'values.description', col: '6', information: { label: 'Description', }, showMain: false },
    //         { type: 'TextInput', key: 'values.address', col: '6', information: { label: 'Office Address', }, showMain: false },

    //         // { title: 'Edit', type: 'button', function: 'edit', options: { color: "#78b2d0" }, showMain: true },
    //         // { title: 'Delete', type: 'button', function: 'remove', options: { color: "#dd8aa4" }, showMain: true }
    //     ],
    // },











    staticPages: {
        key: 'staticPages',
        title: 'Static Pages',
        description: 'Static Pages List',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'staticPages',
        parent: 'website',
        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'values.title', information: { label: 'Title', }, showMain: true },
            { type: 'TextInput', key: 'values.description', information: { label: 'Description', }, showMain: true },
            { type: 'SelectInput', key: 'values.country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true },

            { type: 'TextInput', key: 'values.address', information: { label: 'Url', }, showMain: true },
            { key: 'values.category', col: '6', type: 'SelectInput', information: { label: 'Category', type: 'local', default: '', items: [{ title: "page", value: 'page' }, { title: 'agreement', value: 'agreement' }] }, settings: { required: true }, showMain: true },
            { key: 'values.section', col: '6', type: 'SelectInput', information: { label: 'Section', type: 'local', default: '', items: [{ title: "Users", value: 'Users' }, { title: 'Partners', value: 'Partners' }, { title: 'Buy & Sell', value: 'Buy & Sell' }, { title: 'Web Store', value: 'Web Store' }, { title: 'Others', value: 'Others' }] }, settings: { required: true }, showMain: true },
            { type: 'NumberInput', col: '6', key: 'values.priority', information: { label: 'Priority', }, showMain: true },

            { key: 'values.lng', col: '6', type: 'SelectInput', information: { label: 'language', type: 'local', default: '', items: [{ title: "EN", value: 'EN' }, { title: 'CH', value: 'CH' }, { title: 'MA', value: 'MA' }] }, settings: { required: true }, showMain: true },

            { key: 'values.file', type: 'FileInput', information: { label: 'File', single: true }, showMain: false, fullCol: true, settings: { required: false }, },
            { key: 'values.file2', type: 'FileInput', information: { label: '2nd File', single: true }, hint: 'Only for partners quick guide', showMain: false, fullCol: true, settings: { required: false }, },
            { key: 'values.image', type: 'ImageInput', information: { label: 'Image', single: true, cropper: true, ratio: '3:3', }, showMain: true, fullCol: true },

            { type: 'EditorInput', key: 'values.body', information: { label: 'Body', }, showMain: false, fullCol: true },


        ],
    },




    wallpapers: {
        key: 'wallpapers',
        title: 'Wallpapers',
        description: 'wallpapers List',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'wallpapers',
        parent: 'website',
        image: '/images/covers/1.jpg',
        headers: [
            // { type: 'TextInput', key: 'values.title', information: { label: 'Title', }, showMain: true },
            // { type: 'TextInput', key: 'values.description', information: { label: 'Description', }, showMain: true },

            { type: 'TextInput', key: 'values.address', information: { label: 'Url', }, showMain: true },
            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Creation Date', disabled: true }, showMain: true, inExport: true },

            { type: 'NumberInput', key: 'values.priority', information: { label: 'Priority', }, showMain: true },
            { type: 'SelectInput', key: 'values.country', col: '6', information: { label: 'Country', type: 'api', fields: { value: 'slug', title: 'name' }, address: 'countriesGetAll', filter: { filter: { $or: [{ onlyFor: '0' }] } } }, settings: { required: true }, showMain: true },
            { type: 'SelectInput', key: 'values.type', col: '6', information: { label: 'type', type: 'local', items: [{ title: "Rental", value: 'rental' }, { title: 'Trading', value: 'treding' }, { title: 'Home Page', value: 'homePage' }] }, settings: { required: true }, showMain: true },
            { key: 'values.primaryColor', type: 'AdvancedColorInput', col: '6', information: { label: 'Primary Color', disabled: false, required: false }, showMain: false, inExport: true },


            // { key: 'values.category', type: 'SelectInput', information: { label: 'Category', type: 'local', default: '', items: [{ title: "page", value: 'page' }, { title: 'agreement', value: 'agreement' }] }, settings: { required: true }, showMain: true },

            // { key: 'values.file', type: 'FileInput', information: { label: 'File', single: true }, showMain: false, fullCol: true, settings: { required: false }, },
            // { key: 'values.file2', type: 'FileInput', information: { label: '2nd File', single: true }, hint: 'Only for partners quick guide', showMain: false, fullCol: true, settings: { required: false }, },
            { key: 'values.image', type: 'ImageInput', information: { label: 'Image', single: true, cropper: false, ratio: '5:4', }, showMain: true, fullCol: true, required: true },

            // { type: 'EditorInput', key: 'values.body', information: { label: 'Body', }, showMain: false, fullCol: true },


        ],
    },
    featuredBrand: {
        key: 'featuredBrand',
        title: 'Featured Brands',
        description: 'Featured Brands List',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'featuredBrand',
        parent: 'website',
        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'values.title', information: { label: 'Title', }, showMain: true },
            // { type: 'TextInput', key: 'values.description', information: { label: 'Description', }, showMain: true },

            { type: 'TextInput', key: 'values.address', information: { label: 'Url', }, showMain: true },
            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Creation Date', disabled: true }, showMain: true, inExport: true },

            { type: 'NumberInput', key: 'values.priority', information: { label: 'Priority', }, showMain: true },
            { type: 'SelectInput', key: 'values.country', col: '6', information: { label: 'Country', type: 'api', fields: { value: 'slug', title: 'name' }, address: 'countriesGetAll', filter: { filter: { $or: [{ onlyFor: '0' }] } } }, settings: { required: true }, showMain: true },
            { type: 'SelectInput', key: 'values.type', col: '6', information: { label: 'type', type: 'local', items: [{ title: "Rental", value: 'rental' }, { title: 'Trading', value: 'trading' }] }, settings: { required: true }, showMain: true },

            // { key: 'values.category', type: 'SelectInput', information: { label: 'Category', type: 'local', default: '', items: [{ title: "page", value: 'page' }, { title: 'agreement', value: 'agreement' }] }, settings: { required: true }, showMain: true },

            // { key: 'values.file', type: 'FileInput', information: { label: 'File', single: true }, showMain: false, fullCol: true, settings: { required: false }, },
            // { key: 'values.file2', type: 'FileInput', information: { label: '2nd File', single: true }, hint: 'Only for partners quick guide', showMain: false, fullCol: true, settings: { required: false }, },
            { key: 'values.image', type: 'ImageInput', information: { label: 'Image', single: true, cropper: false, ratio: '5:4', }, showMain: true, fullCol: true, required: true },

            // { type: 'EditorInput', key: 'values.body', information: { label: 'Body', }, showMain: false, fullCol: true },


        ],
    },







    enquiries: {
        key: 'enquiries',
        title: 'Enquiries',
        description: 'Enquiries List',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'enquiries',
        parent: 'website',
        image: '/images/covers/myThings.jpg',
        headers: [
            { key: 'values.name', type: 'TextInput', information: { label: 'Name', }, showMain: true },
            { key: 'values.email', type: 'TextInput', information: { label: 'Email', }, showMain: false },
            { key: 'values.phone', type: 'TextInput', information: { label: 'Phone', }, showMain: false },

            { key: 'cDate', type: 'DateInput', information: { label: 'Date', disabled: true }, showMain: true },

            { key: 'values.body', type: 'TextAreaInput', information: { label: 'body', }, showMain: true },
            { key: 'values.status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'Responded', value: '1' }, { title: 'Ignored', value: '2' }] }, showMain: true },

        ]
    },

    demoRequests: {
        key: 'demoRequests',
        title: 'Demo Requests',
        description: 'Calendly demo booking requests from antbuildz.ai/book-a-demo',
        fetchUrl: 'getDemoRequests',
        addUrl: 'addDemoRequest',
        editUrl: 'addDemoRequest',
        fetchOne: 'getOneDemoRequest',
        removeUrl: 'removeDemoRequest',
        pageType: 'form',
        parent: 'website',
        addNew: -1,
        options: { noAddNew: true },
        sort: { cDate: -1 },
        image: '/images/covers/myThings.jpg',
        headers: [
            { key: 'name', type: 'TextInput', information: { label: 'Full name' }, showMain: true },
            { key: 'email', type: 'TextInput', information: { label: 'Work email' }, showMain: true },
            { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: 'pending', items: [{ title: 'Pending', value: 'pending' }, { title: 'Scheduled', value: 'scheduled' }, { title: 'Contacted', value: 'contacted' }, { title: 'Closed', value: 'closed' }] }, showMain: true },
            { key: 'source', type: 'TextInput', information: { label: 'Source', disabled: true }, showMain: true },
            { key: 'page', type: 'TextInput', information: { label: 'Page', disabled: true }, showMain: false },
            { key: 'calendlyUrl', type: 'TextInput', information: { label: 'Calendly URL', disabled: true }, showMain: false },
            { key: 'cDate', type: 'DateInput', information: { label: 'Requested', disabled: true }, showMain: true },
            { key: 'notes', type: 'TextAreaInput', information: { label: 'Notes' }, showMain: false },
        ]
    },



    // subscribes: {
    //     key: 'subscribes',
    //     title: 'Subscribes Listing',
    //     description: 'Subscribes List',
    //     fetchUrl: 'getAll',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     removeUrl: 'removeValue',
    //     pageType: 'form',
    //     page: 'subscribes',
    //     parent: 'website',
    //     image: '/images/covers/dashboards.jpg',
    //     headers: [
    //         { type: 'TextInput', key: 'values.email', information: { label: 'Email', }, showMain: true },
    //         { key: 'values.status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "unsubscribed", value: '0' }, { title: 'active', value: '1' }] }, settings: { required: false }, showMain: true },


    //     ]
    // },










    brands: {
        key: 'brands',
        title: 'Brands',
        description: 'Brands List',
        fetchUrl: 'getBrands',
        addUrl: 'addBrand',
        editUrl: 'addBrand',
        removeUrl: 'removeBrand',
        pageType: 'form',
        page: 'brands',
        parent: 'extra',
        extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },


        /// SORT
        sort: { 'name': 1 },
        image: '/images/covers/2.jpg',
        headers: [
            { type: 'TextInput', key: 'name', information: { label: 'Name', }, showMain: true, inExport: true },
            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Creation Date', disabled: true }, showMain: true, inExport: true },

            { type: 'SwitchInput', key: 'inFilter', information: { label: 'In Filter', }, showMain: false },
            { key: 'private', type: 'SwitchInput', col: '6', information: { label: 'Private', required: false }, showMain: true },

            // { title: 'Categories', type: 'multiselect', key: 'values.categories', options: { type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'categories' } }, settings: { required: true }, showMain: false },
            // { title: 'Image', key: 'values.image', type: 'image', options: { single: true }, showMain: false, fullCol: true },
            // { label: 'Edit', type: 'button', function: 'edit', options: { color: "#78b2d0" }, showMain: true }, { title: 'Remove', type: 'button', function: 'remove', options: { color: "#dd8aa4" }, showMain: true }
        ],
    },


    attributes: {
        key: 'attributes',
        title: 'Equipment Specification',
        description: 'Equipment Specification List',
        fetchUrl: 'getAttributes',
        addUrl: 'addAttribute',
        editUrl: 'addAttribute',
        removeUrl: 'removeAttribute',
        pageType: 'form',
        page: 'attributes',
        parent: 'extra',
        image: '/images/covers/6.jpg',
        hasTranslation: true,
        // populate: ["categories"],

        headers: [
            { type: 'TextInput', key: 'name', information: { label: 'Name', }, showMain: true, hasTranslation: true, },
            { type: 'TextInput', key: 'nameDesc', information: { label: 'Helping Key', }, showMain: true, hasTranslation: true, },
            { key: 'cDate', type: 'DateInput', col: '6', information: { label: 'Creation Date', disabled: true }, showMain: true, inExport: true },

            { type: 'MultiSelectInput', key: 'categories', information: { label: 'Categories', tag: false, type: 'api', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: '{{country}}' } }, settings: { required: true }, showMain: false },
            { key: 'type', type: 'SelectInput', information: { label: 'Type', type: 'local', items: [{ title: "Slider", value: 'Slider' }, { title: 'Checkbox', value: 'Checkbox' }] }, settings: { required: false }, showMain: true },
            {
                type: 'SubformInput',
                key: 'list',
                col: '12',
                information: {
                    label: 'Specs list',
                    headers: [
                        { type: 'TextInput', col: '4', key: 'title', information: { label: 'Specification', }, showMain: true },
                        { type: 'NumberInput', col: '4', key: 'minvalue', information: { label: 'Min Value', }, showMain: true },
                        { type: 'NumberInput', col: '4', key: 'maxvalue', information: { label: 'Max Value', }, showMain: true },
                        // { type: 'SelectInput', key: 'country', col: '4', information: { label: 'country', placeholder: '{{lang}}country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, showMain: true, fullCol: true },
                    ],

                    placeholder: '{{lang}}country discount',
                    required: false,
                },
                dependencies: [{
                    refKey: 'type',
                    targetKey: 'list',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'Checkbox' } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                }],
                showMain: false
            },
            {
                type: 'NumberInput', key: 'min', col: '6', information: { label: 'Min', },
                dependencies: [{
                    refKey: 'type',
                    targetKey: 'min',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'Slider' } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                }],
                showMain: true
            },
            {
                type: 'NumberInput', key: 'max', col: '6', information: { label: 'Max', },
                dependencies: [{
                    refKey: 'type',
                    targetKey: 'max',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'Slider' } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                }], showMain: true
            },
            {
                type: 'NumberInput', key: 'steps', col: '6', information: { label: 'Steps', },
                dependencies: [{
                    refKey: 'type',
                    targetKey: 'steps',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'Slider' } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                }], showMain: false
            },
            { type: 'MultiSelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true },

            { type: 'TextInput', key: 'suffix', col: '6', information: { label: 'Suffix', }, showMain: true, hasTranslation: true, },
            { type: 'SwitchInput', key: 'isEditableInWiki', col: '6', information: { label: 'Is Editable In Wiki', }, showMain: false },


        ],
    },




    countries: {
        key: "countries",
        title: 'Countries',
        fetchUrl: 'countriesGetAll',
        addUrl: 'countriesCreate',
        editUrl: 'countriesCreate',
        removeUrl: 'countriesRemove',
        pageType: 'form',
        page: 'countries',
        extra: { import: { schema: 'countries', name: 'import', function: 'openImport', icon: '/images/eye.svg' } },
        importAPIName: [],

        parent: 'extra',
        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'name', information: { label: 'Name', }, showMain: true },
            {
                type: 'SubformInput',
                key: 'list',
                col: '12',
                information: {
                    label: 'Google map country Names',
                    headers: [
                        { type: 'TextInput', key: 'mapName', information: { label: 'Map Name', }, showMain: true },
                        // { type: 'SelectInput', key: 'country', col: '4', information: { label: 'country', placeholder: '{{lang}}country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, showMain: true, fullCol: true },
                    ],

                    placeholder: '{{lang}}country discount',
                    required: false,
                },
                showMain: true
            },
            { type: 'TextInput', key: 'slug', col: '6', information: { label: 'slug', }, showMain: true },
            { type: 'TextInput', key: 'iso3', col: '6', information: { label: 'Iso3', }, showMain: true },
            { type: 'TextInput', key: 'iso2', col: '6', information: { label: 'Iso2', }, showMain: true },
            { type: 'TextInput', key: 'currency', col: '6', information: { label: 'Currency', }, showMain: true },
            { type: 'TextInput', key: 'currency_name', col: '6', information: { label: 'Currency_name', }, showMain: true },
            { type: 'NumberInput', key: 'usd_convert', col: '6', information: { label: 'Conversion Rate', }, showMain: true },
            { type: 'TextInput', key: 'defaultLng', col: '6', information: { label: 'DefaultLng', }, showMain: true },
            { key: 'pinned', type: 'SwitchInput', col: '6', information: { label: "Pinned", }, showMain: false },
            { type: 'NumberInput', key: 'GST', col: '6', information: { label: 'GST', }, showMain: true },
            { type: 'NumberInput', key: 'transactionGST', col: '6', information: { label: 'Transaction GST', }, showMain: true },
            { type: 'TextInput', key: 'taxName', col: '6', information: { label: 'tax name', }, showMain: true },
            { type: 'NumberInput', key: 'commission', col: '6', information: { label: 'Commission', }, showMain: true },
            { type: 'NumberInput', key: 'priority', col: '6', information: { label: 'Priority', }, showMain: true },
            { key: 'onlyFor', type: 'MultiSelectInput', col: '6', information: { label: 'Use Only In', placeholder: 'Select ...', type: 'local', items: [{ title: "Rental", value: '0' }, { title: 'Buy / Sell', value: '1' }, { title: 'Sign Up', value: '2' }] }, settings: { required: true }, showMain: true, inExport: true },

            { key: 'icon', type: 'ImageInput', information: { label: 'icon', single: true }, showMain: true, fullCol: true },

            { key: 'active', type: 'SelectInput', information: { label: 'Type', type: 'local', items: [{ title: "active", value: '1' }, { title: 'diacctive', value: '0' }] }, settings: { required: true }, showMain: true },
            { key: 'hasCity', type: 'SwitchInput', col: '6', information: { label: "Has City", }, showMain: false },
            { key: 'availableInHomePage', type: 'SwitchInput', col: '6', information: { label: "Available In Home Page", }, showMain: false },
            { key: 'availableInHomePageBuy', type: 'SwitchInput', col: '6', information: { label: "Available In Home Page Buy", }, showMain: false },
            { key: 'directGST', type: 'SwitchInput', col: '6', information: { label: "Direct GST", }, showMain: false },

            { col: '6', key: '_id', type: 'IdInput', information: { label: '_id', disabled: true, required: false }, showMain: false, inExport: true },

        ],
    },
    // languages: {
    //     key: "languages",
    //     title: 'languages',
    //     fetchUrl: 'languagesGetAll',
    //     addUrl: 'languagesCreate',
    //     editUrl: 'languagesCreate',
    //     removeUrl: 'languagesRemove',
    //     pageType: 'form',
    //     page: 'languages',
    //     extra: { import: { schema: 'languages', name: 'import', function: 'openImport', icon: '/images/eye.svg' } },
    //     importAPIName: [],

    //     parent: 'extra',
    //     image: '/images/covers/1.jpg',
    //     headers: [
    //         { type: 'TextInput', key: 'name', col: '6', information: { label: 'Name', }, showMain: true },
    //         { type: 'TextInput', key: 'localName', col: '6', information: { label: 'Local Name', }, showMain: true },
    //         { type: 'TextInput', key: 'shortName', col: '6', information: { label: 'Short Name', }, showMain: true },
    //         { type: 'NumberInput', key: 'priority', col: '6', information: { label: 'Priority', }, showMain: true },
    //         { key: 'active', type: 'SelectInput', col: '6', information: { label: 'Active', type: 'local', items: [{ title: "active", value: 1 }, { title: 'diacctive', value: 0 }] }, settings: { required: true }, showMain: true },


    //     ],
    // },

    cities: {
        key: "cities",
        title: 'Cities',
        fetchUrl: 'getPlaces',
        addUrl: 'addPlace',
        editUrl: 'addPlace',
        removeUrl: 'removePlace',
        pageType: 'form',
        page: 'cities',
        parent: 'extra',
        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'name', information: { label: 'Name', }, showMain: true },
            // { type: 'TextInput', key: 'mapName', information: { label: 'Map Name', }, showMain: true },
            {
                type: 'SubformInput',
                key: 'list',
                col: '12',
                information: {
                    label: 'Googlemap City Names',
                    headers: [
                        { type: 'TextInput', key: 'mapName', information: { label: 'Map Name', }, showMain: true },
                        // { type: 'SelectInput', key: 'country', col: '4', information: { label: 'country', placeholder: '{{lang}}country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, showMain: true, fullCol: true },
                    ],

                    placeholder: '{{lang}}country discount',
                    required: false,
                },
                showMain: true
            },
            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: { filter: {} } }, settings: { required: true }, showMain: true, required: true },
            { type: 'SelectInput', col: '6', key: 'parent', information: { label: 'Parent', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: { country: '{{country}}' } }, settings: { required: true }, showMain: true },
            { type: 'NumberInput', key: 'priority', information: { label: 'Priority', }, showMain: true, },

        ],
    },
    addresses: {
        key: "addresses",
        title: 'Addresses',
        fetchUrl: 'getAddresses',
        addUrl: 'addPlace',
        editUrl: 'addPlace',
        removeUrl: 'removePlace',
        pageType: 'form',
        page: 'addresses',
        parent: 'extra',
        options: { noAddNew: true },

        image: '/images/covers/1.jpg',
        headers: [
            { type: 'SelectInput', key: 'city', information: { label: 'City', placeholder: 'City ...', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getPlaces', filter: { country: "{{country}}" }, sort: { 'values.priority': 1 }, required: true }, showMain: false },
            // { type: 'TreePlainSelect', key: 'city', information: { label: 'City', placeholder: 'City ...', type: 'api', fields: { value: '_id', title: 'name', parent: 'parent' }, address: 'getPlaces', filter: { country: this.props.user?.info?.country?.slug }, sort: { 'name': 1 }, required: true }, showMain: false },
            { type: 'TextInput', key: 'address', information: { label: 'Address', placeholder: 'Full Address', required: true }, showMain: true },
            { type: 'TextInput', key: 'postalCode', col: '6', information: { label: 'zip code', placeholder: 'zip code / postal code', required: true }, showMain: true },
            { type: 'TextInput', key: 'project', col: '6', information: { label: 'Project Name', placeholder: 'Project Name', required: true }, showMain: true },
            { type: 'MapInput', key: 'location', col: '12', information: { label: 'location', placeholder: 'Project Name', required: true, country: '{{country}}' }, showMain: true },


        ],
    },

    isurances: {
        key: "isurances",
        title: 'Insurances',
        fetchUrl: 'insurancesGetAll',
        addUrl: 'insurancesCreate',
        editUrl: 'insurancesCreate',
        removeUrl: 'insurancesRemove',
        pageType: 'form',
        page: 'countries',
        parent: 'extra',
        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'title', information: { label: 'Title', }, showMain: true },
            { type: 'TextInput', key: 'URL', information: { label: 'URL', }, showMain: true },
            { type: 'TextAreaInput', key: 'description', information: { label: 'description', }, showMain: true },
            { type: 'TextAreaInput', key: 'singleDescription', information: { label: 'single description', }, showMain: true },
            // { type: 'NumberInput', key: 'GST', information: { label: 'GST', }, showMain: true },
            { key: 'icon', type: 'ImageInput', information: { label: 'icon', single: true, }, showMain: true, fullCol: true },
            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true },



        ],
    },



    faq: {
        extra: aiContentImport,
        key: 'faq',
        title: 'FAQs',
        description: 'Frequently Asked Questions',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'faq',
        parent: 'website',
        image: '/images/covers/1.jpg',
        sort: { cDate: -1 },
        hasTranslation: true,
        // postBody: { "values.source": 'rental' },
        headers: [
            { type: 'TextAreaInput', key: 'values.title', information: { label: 'Question', }, hasTranslation: true, showMain: true },
            websiteField('values.websites'),
            { type: 'TextInput', key: 'values.group', information: { label: 'AI Help group' }, showMain: true },
            { type: 'TextInput', key: 'values.sourceId', information: { label: 'Stable content ID' }, showMain: false },
            { type: 'TextInput', key: 'values.href', information: { label: 'Related page URL' }, showMain: false },
            { type: 'TextInput', key: 'values.reference', information: { label: 'Related page label' }, showMain: false },
            { key: 'values.type', type: 'SelectInput', information: { label: 'Type', type: 'local', items: [{ title: "For Users", value: 'users' }, { title: 'For Partners', value: 'partners' }] }, settings: { required: true }, showMain: true },
            { type: 'NumberInput', key: 'values.priority', information: { label: 'Priority', }, showMain: true },
            { type: 'MultiSelectInput', key: 'values.country', col: '6', information: { label: 'Country', showAllInTable: true, type: 'api', fields: { value: 'slug', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: false }, showMain: true },
            { type: 'MultiSelectInput', key: 'values.pages', col: '6', information: { label: '{{lang}}Pages', showAllInTable: true, type: 'local', items: [...aiContentPages, { value: 'home', title: 'Home' }, { value: 'webstorepage', title: 'Web Store Home' }, { value: 'webstore', title: 'Web Store FAQs' }, { value: 'aipages', title: 'AI Page' }, { value: 'partnersguide', title: 'Partners Guide' }, { value: 'userguide', title: 'User Guide' }, { value: 'vehicles', title: 'Vehicles Insurance' }, { value: 'equipment', title: 'Equipment Insurance' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },

            // { title: 'Description', type: 'TextInput', key: 'values.description', showMain: true },
            // { title: 'Url', type: 'TextInput', key: 'values.address', showMain: true },
            { type: 'EditorInput', key: 'values.body', information: { label: 'Answer', }, hasTranslation: true, showMain: false, fullCol: true },

        ],
    },


    announcements: {
        key: 'announcements',
        title: 'Announcement',
        description: 'Announcements list',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'announcements',
        parent: 'extra',
        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'values.title', information: { label: 'Title', }, showMain: true },
            { type: 'MultiSelectInput', key: 'values.country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: false },
            // { title: 'icon', key: 'values.icon', type: 'image', options: { single: true, cropper: true, ratio: '5:3', }, showMain: true, fullCol: true },
            // { title: 'Active', key: 'values.avtive', type: 'boolean', showMain: false, options: { default: true}},
            { type: 'TextInput', key: 'values.url', information: { label: 'url', }, showMain: true },

            { type: 'EditorInput', key: 'values.body', information: { label: 'Body', }, showMain: false, fullCol: true },

        ]
    },



    blogs: {
        key: 'blogs',
        title: 'Blogs',
        description: 'Blogs List',
        fetchUrl: 'getBlogs',
        addUrl: 'addBlog',
        editUrl: 'addBlog',
        hasTranslation: true,
        removeUrl: 'removeBlog',
        pageType: 'form',
        page: 'blogs',
        parent: 'website',

        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'title', information: { label: 'Title', }, hasTranslation: true, showMain: true, fullCol: true },
            { key: 'cover', type: 'ImageInput', information: { label: 'Cover', single: true, cropper: true, ratio: '5:3', }, showMain: true, fullCol: true },
            { type: 'SelectInput', key: 'category', col: '6', information: { label: 'Category', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'blogCategories' } }, settings: { required: true }, showMain: false, fullCol: true },
            { type: 'MultiSelectInput', key: 'special', col: '6', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
            { key: 'active', type: 'SelectInput', information: { default: '1', label: 'Active', type: 'local', items: [{ title: "active", value: '1' }, { title: 'diacctive', value: '0' }] }, settings: { required: false }, showMain: true },

            { type: 'EditorInput', key: 'summery', information: { label: 'Summery', }, hasTranslation: true, showMain: false, fullCol: true },

            { type: 'EditorInput', key: 'body', information: { label: 'Body', }, hasTranslation: true, showMain: false, fullCol: true },


        ]
    },
    resources: {
        extra: aiContentImport,
        key: 'resources',
        title: 'Resources',
        description: 'AI Agent resource articles',
        fetchUrl: 'getResources',
        addUrl: 'addResource',
        editUrl: 'addResource',
        hasTranslation: true,
        removeUrl: 'removeResource',
        pageType: 'form',
        page: 'resources',
        parent: 'website',
        // Roles, industries, tutorials and pageContent blobs are hardcoded on the AI site.
        postBody: { contentKind: { operator: 'in', value: ['article', null] } },

        image: '/images/covers/1.jpg',
        headers: [
            websiteField('websites'),
            { type: 'TextInput', key: 'title', information: { label: 'Title' }, hasTranslation: true, showMain: true, fullCol: true },
            { type: 'TextInput', key: 'slug', information: { label: 'Slug' }, showMain: true, fullCol: true },
            { key: 'cover', type: 'ImageInput', information: { label: 'Cover', single: true, cropper: true, ratio: '5:3' }, showMain: true, fullCol: true },
            { type: 'SelectInput', key: 'category', col: '6', information: { label: 'Category', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'resourceCategories' } }, settings: { required: true }, showMain: true, fullCol: true },
            { type: 'NumberInput', key: 'priority', col: '6', information: { label: 'Priority', }, showMain: true, },
            { type: 'DateInput', key: 'uDate', col: '6', information: { label: 'Update Date', time: false }, showMain: false },

            { key: 'active', type: 'SelectInput',col: '6', information: { default: '1', label: 'Active', type: 'local', items: [{ title: 'active', value: '1' }, { title: 'diacctive', value: '0' }] }, settings: { required: false }, showMain: true },
            { type: 'TextAreaInput', key: 'description', information: { label: 'Description' }, hasTranslation: true, showMain: false, fullCol: true },
            { type: 'TextAreaInput', key: 'targetReader', information: { label: 'Target Reader' }, hasTranslation: true, showMain: false, fullCol: true },
            { type: 'TextAreaInput', key: 'keyPoints', information: { label: 'Key Points (one per line)' }, showMain: false, fullCol: true },
            { type: 'TextAreaInput', key: 'cta', information: { label: 'CTA' }, hasTranslation: true, showMain: false, fullCol: true },
            { type: 'EditorInput', key: 'summery', information: { label: 'Summery' }, hasTranslation: true, showMain: false, fullCol: true },
            { type: 'EditorInput', key: 'body', information: { label: 'Body' }, hasTranslation: true, showMain: false, fullCol: true },
        ]
    },
    userBlogs: {
        key: 'userBlogs',
        title: 'User Blogs',
        description: 'User Blogs List',
        fetchUrl: 'userBlogsGetAll',
        addUrl: 'userBlogsCreate',
        editUrl: 'userBlogsCreate',
        removeUrl: 'userBlogsRemove',
        pageType: 'form',
        page: 'userBlogs',
        parent: 'website',

        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'title', information: { label: 'Title', }, showMain: true, fullCol: true },
            { key: 'active', type: 'SelectInput', col: '6', information: { label: 'Active', placeholder: 'Select ...', type: 'local', default: '0', items: [{ title: "Not Active", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' }, { title: "Blocked By Admin", value: '-2' },] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'userId', type: 'SelectInput', col: '6', information: { self: true, label: 'User', type: 'api', fields: { value: '_id', title: 'company', description: 'name' }, address: 'getUsers', filter: { country: "{{country}}", status: 2 }, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: true, showInfilter: true, inExport: true },

            { key: 'cover', type: 'ImageInput', information: { label: 'Cover', single: true, cropper: true, ratio: '5:3', }, showMain: true, fullCol: true },
            { type: 'SelectInput', key: 'category', col: '6', information: { label: 'Category', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'blogCategories' } }, settings: { required: true }, showMain: false, fullCol: true },
            { type: 'MultiSelectInput', key: 'special', col: '6', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },

            { type: 'EditorInput', key: 'summery', information: { label: 'Summery', }, showMain: false, fullCol: true },

            { type: 'EditorInput', key: 'body', information: { label: 'Body', }, showMain: false, fullCol: true },


        ]
    },

    userFAQs: {
        key: 'userFAQs',
        title: 'User FAQs',
        description: 'User FAQs List',
        fetchUrl: 'userFAQsGetAll',
        addUrl: 'userFAQsCreate',
        editUrl: 'userFAQsCreate',
        removeUrl: 'userFAQsRemove',
        pageType: 'form',
        page: 'userFAQs',
        parent: 'website',

        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'answer', information: { label: 'Answer', }, showMain: true, fullCol: true },
            { type: 'TextInput', key: 'question', information: { label: 'Question', }, showMain: true, fullCol: true },
            { key: 'userId', type: 'SelectInput', col: '6', information: { self: true, label: 'User', type: 'api', fields: { value: '_id', title: 'company', description: 'name' }, address: 'getUsers', filter: { country: "{{country}}", status: 2 }, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: true, showInfilter: true, inExport: true },

            { key: 'active', type: 'SelectInput', col: '6', information: { label: 'Active', placeholder: 'Select ...', type: 'local', default: '0', items: [{ title: "Not Active", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' }, { title: "Blocked By Admin", value: '-2' },] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'type', type: 'SelectInput', col: '6', information: { label: 'Type', placeholder: 'Select ...', type: 'local', items: [{ title: "Rental", value: 'Rental' }, { title: 'Sell', value: 'Sell' }] }, settings: { required: true }, showMain: true, inExport: true },




        ]
    },
    userAgreements: {
        key: 'userAgreements',
        title: 'User Agreements',
        description: 'User Agreements List',
        fetchUrl: 'userAgreementsGetAll',
        addUrl: 'userAgreementsCreate',
        editUrl: 'userAgreementsCreate',
        removeUrl: 'userAgreementsRemove',
        pageType: 'form',
        page: 'userAgreements',
        parent: 'website',

        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'title', information: { label: 'Title', }, showMain: true, fullCol: true },
            { type: 'TextAreaInput', key: 'description', information: { label: 'Description', }, showMain: true, fullCol: true },
            { key: 'active', type: 'SelectInput', col: '6', information: { label: 'Active', placeholder: 'Select ...', type: 'local', default: '0', items: [{ title: "Not Active", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' }, { title: "Blocked By Admin", value: '-2' },] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'userId', type: 'SelectInput', col: '6', information: { self: true, label: 'User', type: 'api', fields: { value: '_id', title: 'company', description: 'name' }, address: 'getUsers', filter: { country: "{{country}}", status: 2 }, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: true, showInfilter: true, inExport: true },
            { type: 'EditorInput', key: 'body', information: { label: 'Body', }, showMain: false, fullCol: true },
            { key: 'file', type: 'FileInput', col: '12', information: { label: 'File', single: false }, fullCol: true, settings: { required: false }, showMain: true },
            { key: 'secondFile', type: 'FileInput', col: '12', information: { label: 'Second File', single: false }, fullCol: true, settings: { required: false }, showMain: true },


        ]
    },
    ticketing: {
        key: 'ticketing',
        title: 'Rental Order Requests',
        description: 'Ticketing list',
        fetchUrl: 'getTickets',
        addUrl: 'postTicket',
        removeUrl: 'removeTicket',
        fetchOneUrl: 'getOneTicketRental',
        addOneUrl: 'postTicketReply',
        // postBody: { type: 'Rental' },
        cantSendMsg: -1,
        pageType: 'list',
        parent: 'main',
        postBody: { archived: { $ne: true }, type: 'Rental' },
        options: {},
        sort: { 'values.priority': -1 },
        image: '/images/back1.jpg',
        headers: [
            // { key: 'user', type: 'AdvancedSelectInput', col: "6", information: { label: '{{lang}}User', address: 'getUsers', filter: {}, fields: { title: 'phone', description: "fullname", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },

            // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true } },
            // { key: 'id', type: 'TextInput', information: { label: '{{lang}}Id', placeholder: '{{lang}}Id', required: false } },

            { key: 'body', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            { key: 'title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            // { key: 'values.parent', type: 'TextInput', information: { label: '{{lang}}parent', placeholder: '{{lang}}parent', required: false } },
            // { type: 'SelectInput', key: 'values.parent', col: '12', information: { label: '{{lang}}parent', address: 'getContents', filter: { page: 'DocumentsCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: false },
            // { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: false } },

            { type: 'SelectInput', key: 'status', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: '{{lang}}Pending' }, { value: '2', title: '{{lang}}Waiting for answer' }, { value: '3', title: '{{lang}}Answered' }, { value: '-1', title: '{{lang}}Closed' }], isSearchable: true, placeholder: '{{lang}}Status', required: true }, showMain: true },

        ]
    },
    recyclebin: {
        key: 'recyclebin',
        title: 'Removed Order Requests',
        description: 'trash list',
        fetchUrl: 'getRemovedTickets',
        addUrl: 'postTicket',
        removeUrl: 'restoreTicket',
        fetchOneUrl: 'getOneTicketRental',
        addOneUrl: 'postTicketReply',
        cantSendMsg: -1,
        pageType: 'list',
        parent: 'main',
        postBody: { type: 'Rental' },
        options: {},
        sort: { 'values.priority': -1 },
        image: '/images/back1.jpg',
        headers: [
            // { key: 'user', type: 'AdvancedSelectInput', col: "6", information: { label: '{{lang}}User', address: 'getUsers', filter: {}, fields: { title: 'phone', description: "fullname", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },

            // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true } },
            // { key: 'id', type: 'TextInput', information: { label: '{{lang}}Id', placeholder: '{{lang}}Id', required: false } },

            { key: 'body', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            { key: 'title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            // { key: 'values.parent', type: 'TextInput', information: { label: '{{lang}}parent', placeholder: '{{lang}}parent', required: false } },
            // { type: 'SelectInput', key: 'values.parent', col: '12', information: { label: '{{lang}}parent', address: 'getContents', filter: { page: 'DocumentsCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: false },
            // { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: false } },

            { type: 'SelectInput', key: 'status', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: '{{lang}}Pending' }, { value: '2', title: '{{lang}}Waiting for answer' }, { value: '3', title: '{{lang}}Answered' }, { value: '-1', title: '{{lang}}Closed' }], isSearchable: true, placeholder: '{{lang}}Status', required: true }, showMain: true },

        ]
    },
    ordersRental: {
        key: 'ordersRental',
        title: 'International Rental Orders',
        description: 'Orders list',
        fetchUrl: 'rentalOrdersAll',
        addUrl: 'rentalOrdersAdd',
        editUrl: 'rentalOrdersAdd',
        removeUrl: 'rentalOrdersRemove',
        // options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'main',
        options: {},
        // sort: { 'cDate': -1 },
        addNew: -1,
        image: '/images/covers/1.jpg',
        extra: { export: { url: 'rentalExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        // postBody: { archived: { $ne: true } },
        populate: ["category"],
        indicators: {
            filter: [
                [{ key: "status" }, '==', '0']
            ],
            color: '#f7f9ff',
            borderColor: '#fff0f0'
        },

        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: "openEditModal", permission: 'view' },
            // PDF: { key: "PDF", label: '{{lang}}Download Insurance PDF', color: '#677dc4', function: "downloadInsurancePDF", permission: 'view' },
            // extendTime: { key: "extendTime", label: '{{lang}}Extend Rental Time', color: '#677dc4', function: "extendRentalTime", permission: 'edit' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },


        tabs: [
            { title: 'Reserved', filter: { "status": '0' } },
            { title: 'Finished', filter: { "status": '3' } },
        ],




        headers: [

            { col: '6', key: 'rentalId', type: 'TextInput', information: { label: 'Description', disabled: true }, showMain: true, disabled: true },
            { col: '6', key: 'status', type: 'SelectInput', fullCol: true, information: { label: 'Status', required: true, type: 'local', default: '0', items: [{ title: "Reserved", value: '0' }, { title: "Waiting For Delivery", value: '1' }, { title: 'Finished', value: '3', color: '#fff', backgroundColor: '#00CD74' }, { title: 'Cancelled By Requester', value: '10' }, { title: 'Cancelled By Ownner', value: '11' }] }, showMain: true, inExport: true },
            // { col: '6', key: 'paymentStatus', type: 'SelectInput', fullCol: true, information: { label: 'Status', required: true, type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: "Done", value: '1' }, { title: 'In rental', value: '2' }, { title: 'Need Payment', value: '3', color: '#fff', backgroundColor: '#00CD74' }, { title: 'Cancelled By Requester', value: '10' }, { title: 'Cancelled By Ownner', value: '11' }] }, showMain: true, inExport: true },
            // { version: null,col:'6', key: 'paymentStatus', type: 'StatusIndicator', thirdCol: true, information: { label: 'Payments', type: 'local', default: '0', relatedKey: 'paymentsList', items: [{ title: "Pending", value: '0', color: '#eee' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }, { title: 'EXPIRED', value: '3', color: '#FF7D9D' }] }, showMain: true },
            { col: '6', key: 'cDate', type: 'DateInput', information: { label: 'Reservation date', }, showMain: true, hideInList: true },

            { col: '12', key: 'description', type: 'TextAreaInput', information: { label: 'Description', }, showMain: false },
            { col: '6', key: 'equipment', type: 'SelectInput', information: { label: 'Equipment', type: 'api', fields: { value: '_id', title: 'equipmentId' }, address: 'getEquipments', filter: {}, linkInfo: { ref: "tequipments", loader: "isPostingData", } }, showMain: true },
            // { col: '6', key: 'customer', type: 'TextInput', information: { label: 'customer', }, showMain: true, settings: { disabled: true }, hideInList: true },
            { col: '6', key: 'customer', type: 'SelectInput', information: { label: "User's Company", type: 'api', fields: { value: '_id', title: 'company', description: 'name' }, address: 'getUsers', filter: {}, linkInfo: { ref: "users", loader: "isPostingData", } }, showMain: false, disabled: true, inExport: true },


        ],






    },
    introcutions: {
        key: 'introcutions',
        title: 'Equipment Introduction',
        description: 'Landing Pages List',
        fetchUrl: 'getIntroductions',
        addUrl: 'addIntroduction',
        editUrl: 'addIntroduction',
        removeUrl: 'removeIntroduction',
        hasTranslation: true,
        pageType: 'form',
        page: 'introcutions',
        parent: 'website',

        image: '/images/covers/1.jpg',
        populate: ["category"],

        headers: [
            ////// LOOKUP
            { type: 'SelectInput', key: 'category', information: { label: 'Category', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getCategories', filter: { country: '{{country}}' } }, settings: { required: true, url: '/categories/getOne', page: "categories", showInfo: true, disabled: false }, showMain: true },
            { type: 'NumberInput', key: 'priority', information: { label: 'Priority', }, showMain: true, },

            { type: 'EditorInput', key: 'summery', information: { label: 'Summery', }, hasTranslation: true, showMain: true, fullCol: true },
            { type: 'EditorInput', key: 'body', information: { label: 'Body', }, hasTranslation: true, showMain: false, fullCol: true },
            { type: 'EditorInput', key: 'faq', information: { label: 'Faq', }, hasTranslation: true, showMain: false, fullCol: true },



        ]
    },


    blogCategories: {
        key: 'blogCategories',
        title: 'Blog Categories',
        description: 'Blog Categories List',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'blogCategories',
        parent: 'extra',
        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'values.name', information: { label: 'Name', }, showMain: true, fullCol: true },
            { key: 'values.image', type: 'ImageInput', information: { label: 'Image', single: true, cropper: true, ratio: '5:3', }, showMain: true, fullCol: true },


        ],
    },

    resourceCategories: {
        key: 'resourceCategories',
        title: 'Resource Categories',
        description: 'Resource categories for Main website and AI website',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'resourceCategories',
        parent: 'website',
        image: '/images/covers/1.jpg',
        headers: [
            {
                type: 'MultiSelectInput',
                key: 'values.websites',
                col: '6',
                information: {
                    label: 'Websites',
                    type: 'local',
                    items: websiteItems,
                    showAllInTable: true,
                    isSearchable: true,
                    hint: 'Use Main website only for static AI Roles, Industries and Tutorials categories so they stay off antbuildz.ai.',
                },
                showMain: true,
            },
            { type: 'TextInput', key: 'values.name', information: { label: 'Name' }, showMain: true, fullCol: true },
            { type: 'TextInput', key: 'values.slug', information: { label: 'Slug' }, showMain: true, fullCol: true },
            { type: 'TextAreaInput', key: 'values.description', information: { label: 'Description' }, showMain: true, fullCol: true },
            { type: 'NumberInput', key: 'values.priority', information: { label: 'Priority (sort order)' }, showMain: true, fullCol: true },
            { key: 'active', type: 'SelectInput', col: '6', information: { default: '1', label: 'Active', type: 'local', items: [{ title: 'active', value: '1' }, { title: 'diacctive', value: '0' }] }, showMain: true },
        ],
    },




    breakdowns: {
        key: 'breakdowns',
        title: 'Breakdowns',
        description: 'Breakdowns List',
        fetchUrl: 'getBreakdowns',
        addUrl: 'addBreakdown',
        editUrl: 'addBreakdown',
        removeUrl: 'removeBreakdown',
        pageType: 'form',
        page: 'breakdowns',
        parent: 'extra',
        image: '/images/covers/3.jpg',
        indicators: {
            filter: [
                [{ key: "status" }, '==', '1']
            ],
            color: '#fff7f7',
            borderColor: '#fff0f0'
        },
        addNew: -1,
        options: { noAddNew: true },
        sort: { 'updateDate': -1 },

        headers: [

            { type: 'SelectInput', key: 'rentalId', information: { label: 'Rental Id', type: 'api', fields: { value: '_id', title: 'rentalId' }, address: 'getRentals', filter: {} }, showMain: true },
            { key: 'description', type: 'TextAreaInput', information: { label: 'Description', }, showMain: true, },
            { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', items: [{ title: "No problem", value: '0' }, { title: 'Breakdown', value: '1' }, { title: 'In progress', value: '2' }, { title: 'Resolved', value: '3' }] }, settings: { required: true }, showMain: true },


        ]
    },






    vouchers: {
        key: 'vouchers',
        title: 'Voucher Listing',
        description: 'Generated Voucher List',
        fetchUrl: 'getVouchers',
        fetchOne: 'getOneVoucher',

        addUrl: 'addVoucher',
        editUrl: 'addVoucher',
        removeUrl: 'removeVoucher',
        pageType: 'form',
        parent: 'extra',
        // populate: ["category", 'brand'],
        // options: { noAddNew: true },
        // addNew: -1,
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

        tabs: [
            { title: 'Not Used', filter: { "status": '0' } },
            { title: 'Used', filter: { "status": '1' } },
        ],

        page: 'vouchers',
        image: '/images/covers/2.jpg',
        headers: [

            { key: 'id', type: 'TextInput', col: '6', information: { label: 'Voucher Id', disabled: false }, showMain: true, inExport: true },
            // { key: 'currency', type: 'TextInput', col: '6', information: { label: 'Currency', }, showMain: true, inExport: true, disabled: true },
            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Currency', type: 'api', fields: { value: '_id', title: 'currency' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true },

            { key: 'amount', type: 'PriceInput', col: '6', information: { label: 'Amount', }, showMain: true, inExport: true },
            { key: 'min', type: 'PriceInput', col: '6', information: { label: 'Minimum Amount', }, inExport: true, showMain: false },
            { key: 'user', type: 'SelectInput', col: '6', information: { label: 'user', type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: { country: "{{country}}" }, linkInfo: { ref: "users", loader: "isPostingData", } }, showMain: false },
            { key: 'user.company', type: 'TextInput', col: '6', information: { label: 'user', type: 'api', }, showMain: true, hideInList: true },
            { key: 'user.email', type: 'TextInput', col: '6', information: { label: 'email', type: 'api', }, showMain: true, hideInList: true },

            { type: 'DateInput', key: 'cDate', col: '6', information: { label: 'Create Date', time: false }, showMain: true },
            { type: 'DateInput', key: 'eDate', col: '6', information: { label: 'Expire Date', time: false, startOrEnd: 'end' }, showMain: true },
            { type: 'DateInput', key: 'uDate', col: '6', information: { label: 'Use Date', time: false }, showMain: true },



            { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Not Used", value: '0' }, { title: 'Used', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: 'Description', }, showMain: false, },


        ]
    },
    subscriptionVouchers: {
        key: 'subscriptionVouchers',
        title: 'Subscription Voucher Listing',
        description: 'Generated Voucher List',
        fetchUrl: 'getVouchersSubscription',
        fetchOne: 'getOneVoucherSubscription',

        addUrl: 'addVoucherSubscription',
        editUrl: 'addVoucherSubscription',
        removeUrl: 'removeVoucherSubscription',
        pageType: 'form',
        parent: 'extra',
        // populate: ["category", 'brand'],
        // options: { noAddNew: true },
        // addNew: -1,
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

        tabs: [
            { title: 'Not Used', filter: { "status": '0' } },
            { title: 'Used', filter: { "status": '1' } },
        ],

        page: 'vouchers',
        image: '/images/covers/2.jpg',
        headers: [

            { key: 'voucherId', type: 'TextInput', col: '6', information: { label: 'Voucher Id', disabled: false }, showMain: true, inExport: true },
            // { key: 'type', type: 'SelectInput', col: '6', information: { label: 'Type', type: 'local', items: [{ title: "Personal", value: '0' }, { title: 'General', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },
            // { key: 'currency', type: 'TextInput', col: '6', information: { label: 'Currency', }, showMain: true, inExport: true, disabled: true },

            { key: 'amount', type: 'PriceInput', col: '6', information: { label: 'Amount', }, showMain: true, inExport: true },
            // { key: 'limitOfUse', type: 'NumberInput', col: '6', information: { label: 'working hour', }, showMain: false, fullCol: true, inExport: true },
            { key: 'user', type: 'SelectInput', col: '6', information: { label: 'user', type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: { country: "{{country}}" }, linkInfo: { ref: "users", loader: "isPostingData", } }, showMain: false },
            { key: 'user.company', type: 'TextInput', col: '6', information: { label: 'user', type: 'api', }, showMain: true, hideInList: true },
            { key: 'user.email', type: 'TextInput', col: '6', information: { label: 'email', type: 'api', }, showMain: true, hideInList: true },
            { type: 'NumberInput', key: 'voucherCycles', col: '6', information: { label: 'Cycles To Affect', }, showMain: true },
            { type: 'MultiSelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: true },
            { key: 'subscriptionPlan', type: 'MultiSelectInput', col: '6', information: { label: 'Subscription Plan', type: 'api', fields: { value: '_id', title: 'name', description: 'description' }, address: 'getSubscriptionPlans', filter: {} }, showMain: true },

            { type: 'DateInput', key: 'cDate', col: '6', information: { label: 'Create Date', time: false }, showMain: true },
            { type: 'DateInput', key: 'eDate', col: '6', information: { label: 'Expire Date', time: false, startOrEnd: 'end' }, showMain: true },
            { type: 'DateInput', key: 'uDate', col: '6', information: { label: 'Use Date', time: false }, showMain: true },



            { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Not Used", value: '0' }, { title: 'Used', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: 'Description', }, showMain: false, },


        ]
    },










    employees: {
        key: "employees",
        title: 'Employees',
        description: 'Employees List',
        fetchUrl: 'getEmployees',
        addUrl: 'addEmployee',
        editUrl: 'addEmployee',
        removeUrl: 'removeEmployee',
        pageType: 'form',
        page: 'partners',
        parent: 'admin',
        // addNew: -1,
        options: { noAddNew: true },

        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', col: '6', key: 'name', information: { label: 'Name', }, showMain: true },
            { type: 'TextInput', col: '6', key: 'username', information: { label: 'Username', }, showMain: true },
            { type: 'TextInput', col: '6', key: 'phone', information: { label: 'Phone Number', }, showMain: false },
            { type: 'TextInput', col: '6', key: 'email', information: { label: 'Email', }, showMain: false },
            { type: 'PasswordInput', key: 'password', information: { label: 'Password', }, showMain: false },

        ],
    },
    AutoGens: {
        key: "AutoGens",
        title: 'AutoGens',
        description: 'AutoGens List',
        fetchUrl: 'getAutoGens',
        addUrl: 'addAutoGen',
        editUrl: 'addAutoGen',
        removeUrl: 'removeAutoGen',
        pageType: 'form',
        page: 'partners',
        parent: 'admin',
        // addNew: -1,
        options: { noAddNew: true },

        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', col: '6', key: 'format', information: { label: 'format', }, showMain: true },
            { type: 'TextInput', col: '6', key: 'app', information: { label: 'app', }, showMain: true },
            { type: 'TextInput', col: '6', key: 'resetNum', information: { label: 'resetNum', }, showMain: true },
            { type: 'TextInput', col: '6', key: 'key', information: { label: 'key ', }, showMain: true },
            { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: false },

            // { type: 'TextInput', col: '6', key: 'email', information: { label: 'Email', }, showMain: false },
            // { type: 'PasswordInput', key: 'password', information: { label: 'Password', }, showMain: false },
            { type: 'DateInput', key: 'updateDate', col: '6', information: { label: 'update Date', time: false }, showMain: true },
            { key: 'number', type: 'NumberInput', col: '6', information: { label: 'Number', }, showMain: false, fullCol: true, inExport: true },

        ],
    },




    logs: {
        key: "logs",
        title: 'Logs',
        description: 'Logs List',
        fetchUrl: 'getInbox',
        // addUrl: 'addEmployee',
        // editUrl: 'addEmployee',
        // removeUrl: 'removeEmployee',
        pageType: 'form',
        page: 'logs',
        parent: 'admin',
        addNew: -1,
        options: { noAddNew: true },
        actions: {},
        tabs: [
            { title: 'Admins', filter: { "role": 'admin' } },
            { title: 'Users', filter: { "role": 'user' } },

        ],

        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'message', information: { label: 'Message', }, showMain: true },
            { type: 'DateInput', key: 'cDate', information: { label: 'Date/Time', time: true, disabled: true }, showMain: true },

            { type: 'TextInput', key: 'type', information: { label: 'Type', }, showMain: true },

        ],
    },
    subscriptionLogs: {
        key: "subscriptionLogs",
        title: 'Subscription Logs',
        description: 'Subscription Logs List',
        fetchUrl: 'getInboxSub',
        // addUrl: 'addEmployee',
        // editUrl: 'addEmployee',
        removeUrl: 'removeSub',
        pageType: 'form',
        page: 'logs',
        parent: 'admin',
        addNew: -1,
        options: { noAddNew: true },
        actions: {},
        // tabs: [
        //     { title: 'Admins', filter: { "role": 'admin' } },
        //     { title: 'Users', filter: { "role": 'user' } },

        // ],

        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'message', information: { label: 'Message', }, showMain: true },
            { type: 'DateInput', key: 'cDate', information: { label: 'Date/Time', time: true, disabled: true }, showMain: true },

            { type: 'TextInput', key: 'type', information: { label: 'Type', }, showMain: true },

        ],
    },



    permissions: {
        key: 'permissions',
        title: 'permissions',
        description: 'permissions List',
        fetchUrl: 'getPermissions',
        removeUrl: 'removePermission',
        // editUrl: 'addValue',
        // removeUrl: 'removeValue',
        pageType: 'form',
        page: 'permissions',
        parent: 'admin',
        image: '/images/covers/dashboards.jpg',
        addNew: '/admin/permission',
        hideFilter: true,
        headers: [
            // { key: 'groups', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}useful.groups', placeholder: '{{lang}}useful.groups', required: false, disabled: true }, showMain: true },
            { key: 'users', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}Users', fields: { title: 'username', value: '_id' }, placeholder: '{{lang}}useful.users', required: false, disabled: true, showAllInTable: true }, showMain: true },

            { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false, disabled: true }, showMain: true },


        ]
    },


    permission: {
        key: 'permission',
        title: 'permission',
        description: 'permission List',
        fetchUrl: 'getPermission',
        addUrl: 'addPermission',
        editUrl: 'addPermission',
        // removeUrl: 'removePermission',
        pageType: 'permissions',
        page: 'permissions',
        permissionRules: ['admin.permissions.create', 'admin.permissions.edit'],
        permissionParent: 'permissions',
        // parent: 'admin',
        image: '/images/covers/dashboards.jpg',

        headers: [
            { type: 'TextInput', key: 'email', information: { label: 'Email', }, showMain: true },
            { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "unsubscribed", value: '0' }, { title: 'active', value: '1' }] }, settings: { required: false }, showMain: true },


        ]
    },

















}


export { adminPages, adminSections }
